/* eslint-disable no-lone-blocks */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import {
Menu,
Space,
Drawer,
Dropdown,
Button,
Radio,
Tag,
Row,
Pagination,
Col,
Typography,
Checkbox,
notification } from
"antd";
import { gql, useLazyQuery } from "@apollo/client";
import { RestLink } from "apollo-link-rest";
import moment from "moment";
import { useParams } from "react-router-dom";

import downArrow from "../../assets/icons/downArrow.png";

import {
SearchResponse,
SearchResponseRequested,
SearchValue,
GetFilters,
skillListingTotalCount,
skillListingCount,
fetchKeySearchDynamicLocation,
fetchKeySearchCompanyAndIndustries,
fetchKeySearchSkills,
ClearSearchIconClicked,
getCandidatesCount,
addBatchMatches } from
"../../redux/actions";

import { HttpLink } from "apollo-link-http";
import { DownOutlined } from "@ant-design/icons";

import { useDispatch, useSelector } from "react-redux";
import MobilePagination from "../../components/Pagination/MobilePagination";
import emptyresult from "../../assets/img/cuate@2x.png";

// CSS


// ICONS
import { LoadingOutlined, CloseOutlined } from "@ant-design/icons";
import {
GetQueryParams,
debounce,
decodeSpecialCharacter,
getGigDetails,
timeout, isNonHC } from
"../../shared/helpers";
import FilterIcon from "../../assets/img/filtericon.svg";
import SortIcon from "../../assets/img/sorticon.svg";
import AiImage from "../../assets/icons/AiImage.svg";
import AI_Suggested from "../../assets/img/AI_Suggested.png";
// ANTD
import GigsCard from "./GigsCard";
import { connect } from "react-redux";
// redux Actions
import { useLocation } from "react-router";
import history from "../../routes/history";
import Filters from "./MobileComponents/Filters";
import PlaceBidModal from "../../components/PlaceBidModal/PlaceBidModal";
import BudgetFilter from "./components/BudgetFilter/BudgetFilter";
import ExperienceLevel from "./components/ExperienceLevelFilter/ExperienceLevelFilter";
import FilterLocation from "./components/LocationFilter/location.filter.js";
import FilterRegion from "../SearchSkillListing/components/LocationFilter/region.Filter.js";
import FilterState from "../SearchSkillListing/components/LocationFilter/state.Filter.js";
import { ProfessionFilter } from "./components/professionFilter/professionFilter";
import { DefaultRating } from "../../assets/helpers";
import FilterCompany from "../SearchSkillListing/components/LocationFilter/company.Filter";
import FilterIndustry from "../SearchSkillListing/components/LocationFilter/prev.Filter";
import FilterSkill from "../SearchSkillListing/components/LocationFilter/skill.Filter";
import FilterVisa from "../SearchSkillListing/components/LocationFilter/visa.Filter";
import { TAL_AUTO_SUGGESTED } from "./../../shared/constants";
import { alertNotification } from "./../../components/TopNotification/alertNotification";
import "./SearchResults.css";

const SearchResults = React.memo((props) => {
  const dispatch = useDispatch();
  const url = useLocation();
  const { id } = useParams();
  const queryparams = GetQueryParams();
  const queryParams = new URLSearchParams(window.location.search);
  const isTalentSuggestion = [true, "true"].includes(
  queryParams.get("isTalentSuggestion"));


  const { Text } = Typography;
  const { authToken } = props;

  // searchSkillListingReducer
  const LocalSelectedSkillListings = JSON.parse(
  localStorage.getItem("SelectedSkillsSearch"));


  const counts = useSelector(
  (state) => state.manageJobsReducer.candidateCounts);


  const filters = useSelector(
  (state) => state.searchSkillListingReducer.filters);


  const keywords = useSelector(
  (state) => state.getSearchSuggestionReducer.keywords);


  const token = useSelector((state) => state.authReducer.user);
  const profileTypeRes = useSelector((state) => state.profileReducer.user);

  const [windowDimensions, setWindowDimensions] = useState(
  getWindowDimensions());


  const [checkBox, setCheckedBox] = useState([]);

  const totalCount = useSelector(
  (state) => state.searchSkillListingReducer.skillListingTotalCount);


  const totalCountError = useSelector(
  (state) => state.searchSkillListingReducer.error);

  const { batchMatchLoading } = useSelector(
  (state) => state.MatchedSkillReducer);


  let userProfile = JSON.parse(localStorage.getItem("userProfile"));

  const [checkRadio, setCheckRadio] = useState(null);
  const [filterError, setFilterError] = useState("");

  const [searchFilters, setSearchFilters] = useState({
    location: [],
    cityId: [],
    regionId: [],
    countryId: [],
    city: null,
    region: [],
    state: [],
    skillListing_type: null,
    budgetType: null,
    ExperienceLevel: [],
    budgetMin: null,
    budgetMax: null,
    NearBy: null,
    hidePrevious: null,
    ProfessionCode: null,
    visa: [],
    visaName: [],
    company: null,
    industry: [],
    industryId: [],
    skill: [],
    skillsId: []
  });

  const [skillListings, setGigs] = useState([]);
  const [visible, setVisible] = useState(false);
  const [sortvisible, setSortVisible] = useState(false);
  const [sortType, setSortType] = useState("MOST_RELEVANT");
  const [sortTypeText, setsortTypeText] = useState("Most relevant");
  const [pageNo, setPageNo] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [latitude, setLatitude] = useState(
  localStorage.getItem("latitude") ?? null);

  const [longitude, setLongitude] = useState(
  localStorage.getItem("longitude") ?? null);


  const [isformOpen, setIsFormOpen] = useState(false);
  const [placebidModal, setplacebidModal] = useState(false);
  const [showChooseGigModal, setShowChooseGigModal] = useState(false);
  const [candidateList, setcandidateList] = useState([]);
  const [locationValue, setLocationValue] = useState([]);

  const [jobTypeRadio, setJobTypeRadios] = useState(
  queryparams.skillListing_type ?? null);

  const [candidateTypeRadio, setcandidateTypeRadio] = useState(
  queryparams?.isPrivateTalent ?? false);


  const [checkAllClicked, setcheckAllClicked] = useState(false);
  const [selectText, setSelectText] = useState(true);
  const [skillListingIds, setSkillListingIds] = useState(
  JSON.parse(localStorage.getItem("SelectedSkillsSearch")) ?? []);

  const [filterCount, setFilterCount] = useState();
  const [closeModalSkill, setCloseModalSkill] = useState(false);
  const [closeCandidateModal, setCloseCandidateModal] = useState(false);
  const [professionDropdownOpen, setProfessionDropdownOpen] = useState(false);
  const [closeModalLoc, setCloseModalLoc] = useState(false);
  const [closeModalRegion, setCloseModalRegion] = useState(false);
  const [closeModalState, setCloseModalState] = useState(false);
  const [closeModalBudget, setCloseModalBudget] = useState(false);
  const [closeModalExp, setCloseModalExp] = useState(false);
  const [closeModalSkill1, setCloseModalSkill1] = useState(false);
  const [closeModalCompany, setCloseModalCompany] = useState(false);
  const [closeModalVisa, setCloseModalVisa] = useState(false);
  const [closeModalPrev, setCloseModalPrev] = useState(false);

  const [clearForm, setClearForm] = useState(false);
  const [uniqueSuggestion, setUniqueSuggestion] = useState([]);
  const [budget, setBudget] = useState({
    budgetMin: null,
    budgetMax: null,
    budgetType: null
  });
  const [perPage, setPerPage] = useState(24);
  const [checkRadioLoc, setCheckRadioLoc] = useState([]);
  const [checkRadioRegion, setCheckRadioRegion] = useState([]);
  const [checkRadioVisa, setCheckRadioVisa] = useState([]);
  const [checkRadioVisaName, setCheckRadioVisaName] = useState(null);
  const [professionSelected, setProfessionSelected] = useState("All");
  const [checkRadioCountry, setCheckRadioCountry] = useState([]);
  const [checkRadioCompany, setCheckRadioCompany] = useState(null);
  const [checkRadioIndustry, setCheckRadioIndustry] = useState([]);
  const [checkRadioSkill, setCheckRadioSkill] = useState([]);
  const [hideCheck, setHideCheck] = useState(null);

  const [checkCityId, setCheckCityId] = useState([]);
  const [checkSkillId, setCheckSkillId] = useState([]);
  const [checkIndustryId, setCheckIndustryId] = useState([]);
  const [checkRegionId, setCheckRegionId] = useState([]);
  const [checkCountryId, setCheckCountryId] = useState([]);
  const [emptyCityInput, setEmptyCityInput] = useState();
  const [emptyRegionInput, setEmptyRegionInput] = useState();
  const [emptyCountryInput, setEmptyCountryInput] = useState();
  const [emptyPrevIndustryInput, setEmptyPrevIndustryInput] = useState();
  const [emptyCompanyInput, setEmptyCompanyInput] = useState();
  const [emptyIndustryInput, setEmptyIndustryInput] = useState();
  const [emptySkillInput, setEmptySkillInput] = useState();
  const [HidePagePvt, setHidePagePvt] = useState(false);

  //for city
  const [checkLocObject, setCheckLocObject] = useState({
    value: checkRadioLoc ?? null,
    value2: parseInt(checkCityId) ?? null
  });
  // for region

  const [checkRegionObject, setCheckRegionObject] = useState({
    value: checkRadioRegion ?? [],
    value2: parseInt(checkRegionId) ?? []
  });

  // for country
  const [checkCountryObject, setCheckCountryObject] = useState({
    value: checkRadioCountry ?? [],
    value2: parseInt(checkCountryId) ?? []
  });

  // for country
  const [checkSkillObject, setCheckSkillObject] = useState({
    value: checkRadioSkill ?? [],
    value2: parseInt(checkSkillId) ?? []
  });

  // for industry
  const [checkIndustryObject, setCheckIndustryObject] = useState({
    value: checkRadioIndustry ?? [],
    value2: parseInt(checkIndustryId) ?? []
  });

  // for previous industry
  const [prevIndustryObj, setPrevIndustryObj] = useState({
    value: checkRadioCountry ?? [],
    value2: parseInt(checkCountryId) ?? []
  });

  useEffect(() => {
    if (LocalSelectedSkillListings == null) {
      setSkillListingIds(
      typeof LocalSelectedSkillListings === "string" ?
      JSON.parse(LocalSelectedSkillListings) :
      LocalSelectedSkillListings);

    }
  }, [LocalSelectedSkillListings]);

  const [gqlError, setGqlError] = useState();

  const [searchType, setSearchType] = useState("Skills");

  let searchKeyword = replaceSpecialChars(
  url?.pathname?.split("query")[1]?.slice(1))?.
  replaceAll('"', "");

  const [searcheyword, setSearchKeyword] = useState(searchKeyword);

  function replaceSpecialChars(str) {
    if (str) {
      return decodeURIComponent(
      str.replace(/%(?![0-9][0-9a-fA-F]+)/g, "%20", "%25"));

    } else if (props.job_title) {
      return props.job_title.join("$");
    } else {
      return null;
    }
  }

  const [clearSort, setClearSort] = useState(false);
  const [searchLocationFilter, setsearchLocationFilter] = useState({});

  const getPrivateParams = () =>
  queryparams?.isPrivate ?
  { AbsPrivateTalent: true } :
  {
    AbsPrivateTalent: searchFilters?.isPrivateTalent == true || undefined
  };

  useEffect(() => {
    const obj = {
      ...getPrivateParams(),
      _page: 1,
      _perPage: perPage,
      _sort: sortType,
      search: searchKeyword ?? "",
      hide: true,

      NearBy: searchFilters.NearBy ? true : null,
      Latitude: localStorage.getItem("latitude") ?
      localStorage.getItem("latitude").toString() :
      null,
      Longitude: localStorage.getItem("longitude") ?
      localStorage.getItem("longitude").toString() :
      null,

      maxDistance: "50",

      BudgetMax: budget.budgetMax,
      BudgetMin: budget.budgetMin,
      BudgetType: budget.budgetType,
      GigType: jobTypeRadio,
      CityId: checkCityId,
      RegionId: checkRegionId,
      CountryId: checkCountryId,
      SkillsId: checkSkillId,
      // Location: checkRadioLoc,
      Experience: checkBox, //checkRadio,
      searchType: searchType,
      ProfessionCode: professionSelected == "All" ? null : professionSelected
    };
    const params = { obj };
    setsearchLocationFilter(params);
  }, [searchFilters, props.job_title, props.value, searchType]);

  const obj = {
    ...getPrivateParams(),
    _page: 1,
    _perPage: perPage,
    _sort: sortType,
    search:
    props.value === 0 ?
    "" :
    props.job_title ?
    props.job_title.join("$") :
    props.value,

    NearBy: searchFilters.NearBy ? true : null,
    Latitude: localStorage.getItem("latitude") ?
    localStorage.getItem("latitude").toString() :
    null,
    Longitude: localStorage.getItem("longitude") ?
    localStorage.getItem("longitude").toString() :
    null,

    maxDistance: "50",
    hide: hideCheck ? true : null,

    BudgetMax: budget.budgetMax,
    BudgetMin: budget.budgetMin,
    BudgetType: budget.budgetType,
    GigType: jobTypeRadio,
    CityId: checkCityId,
    RegionId: checkRegionId,
    SkillsId: checkSkillId,
    CountryId: checkCountryId,
    Experience: checkBox, //checkRadio,
    searchType: searchType,
    ProfessionCode: professionSelected
  };

  useEffect(() => {
    {
      props.type ?
      props.type == "Skill Listings" ?
      setSearchType("Skills") :
      props.type == "Candidate Name" ?
      setSearchType("UserName") :
      props.type == "Email" ?
      setSearchType("Email") :
      props.type == "Work history" ?
      setSearchType("workHistory") :
      setSearchType("Skills") :
      setSearchType(
      queryparams?.searchType ?
      queryparams?.searchType :
      props.job_title ?
      "Match" :
      "Skills");

    }
  }, [props.type]);

  useEffect(() => {
    setSearchKeyword(searchKeyword);
  }, [searchKeyword]);

  const defaultemptyObj = {
    _page: 1,
    _perPage: null,
    _sort: sortType,
    search: "",
    hide: true,
    NearBy: searchFilters.NearBy ? true : null,
    Latitude: localStorage.getItem("latitude") ?
    localStorage.getItem("latitude").toString() :
    null,
    Longitude: localStorage.getItem("longitude") ?
    localStorage.getItem("longitude").toString() :
    null,
    maxDistance: "50",
    BudgetMax: null,
    BudgetMin: null,
    BudgetType: null,
    GigType: null,
    CityId: [],
    RegionId: [],
    CountryId: [],
    Experience: [],
    SkillsId: [],
    searchType: searchType,
    ProfessionCode: professionSelected == "All" ? null : professionSelected
  };

  useEffect(() => {
    if (url.search != "") {
      setPageNo(
      url.search?.split("pageNo=")[1] ?
      parseInt(url.search?.split("pageNo=")[1]) :
      1);

      setCurrentPage(
      url.search?.split("pageNo=")[1] ?
      parseInt(url.search?.split("pageNo=")[1]) :
      1);


      setSortType(
      url?.search?.
      split("&")?.
      find((param) => param.includes("sortType="))?.
      split("sortType=")[1]?.
      split("&")[0] ?? "MOST_RELEVANT");

      setSearchType(
      queryparams?.searchType ?
      queryparams?.searchType :
      props.job_title ?
      "Match" :
      "Skills");

      setsortTypeText(
      url?.search?.
      split("&")?.
      find((param) => param.includes("sortType="))?.
      split("sortType=")[1]?.
      split("&")[0] == "MOST_RECENT" ?
      "New skill listing" :
      url?.search?.
      split("&")?.
      find((param) => param.includes("sortType="))?.
      split("sortType=")[1]?.
      split("&")[0] == "MOST_RELEVANT" ?
      "Most Relevant" :
      url?.search?.
      split("&")?.
      find((param) => param.includes("sortType="))?.
      split("sortType=")[1]?.
      split("&")[0] == "MOST_NEWEST" ?
      "Last Active" :
      url?.search?.
      split("&")?.
      find((param) => param.includes("sortType="))?.
      split("sortType=")[1]?.
      split("&")[0] == "RATINGS_HIGH_TO_LOW" ?
      "Ratings High to Low" :
      url?.search?.
      split("&")?.
      find((param) => param.includes("sortType="))?.
      split("sortType=")[1]?.
      split("&")[0] == "RATINGS_LOW_TO_HIGH" ?
      "Ratings Low to High" :
      url?.search?.
      split("&")?.
      find((param) => param.includes("sortType="))?.
      split("sortType=")[1]?.
      split("&")[0] == "PAY_HI_TO_LOW" ?
      "Desired Rate High to Low" :
      url?.search?.
      split("&")?.
      find((param) => param.includes("sortType="))?.
      split("sortType=")[1]?.
      split("&")[0] == "PAY_LOW_TO_HI" ?
      "Desired Rate Low to High" :
      "Most Relevant");


      setcheckAllClicked(false);
      setSelectText(true);
      setBudget({
        budgetMax: url?.search.split("budgetMax=")[1]?.split("&")[0] ?? null,
        budgetMin: url?.search.split("budgetMin=")[1]?.split("&")[0] ?? null,
        budgetType: url?.search.split("budgetType=")[1]?.split("&")[0] ?? null
      });
      setHideCheck(url?.search.split("hide=")[1]?.split("&")[0] ?? null);
      setCheckCityId(
      queryparams?.cityId ?
      JSON.parse(queryparams?.cityId?.replaceAll("+", "")) :
      []);


      setJobTypeRadios(
      url?.search?.
      split("skillListing_type=")[1]?.
      split("&")[0]?.
      replaceAll("+", " ")?.
      replaceAll("%2C", ",") ?? null);

      setcandidateTypeRadio(
      [true, "true"].includes(
      url?.search?.split("isPrivateTalent=")[1]?.split("&")[0] ?? null));


      setCheckRegionId(
      queryparams?.regionId ? JSON.parse(queryparams?.regionId) : []);

      setCheckRadioRegion(
      queryparams.Region ? JSON.parse(queryparams?.Region) : []);

      setCheckCountryId(
      queryparams?.countryId ? JSON.parse(queryparams?.countryId) : []);

      setCheckSkillId(
      queryparams?.skillsId ? JSON.parse(decodeSpecialCharacter(queryparams?.skillsId)) : []);

      // here
      setCheckedBox(
      queryparams?.experience ?
      JSON.parse(queryparams?.experience?.replaceAll("+", " ")) :
      []);

      setCheckRadio(queryparams.experience ?? null);
      setProfessionSelected(
      url?.search?.split("ProfessionCode=")[1]?.split("&")[0] ?? "All");

      setCheckRadioLoc(queryparams?.City ? JSON.parse(queryparams?.City) : []);

      //city
      const cityQueryParam = queryparams?.City?.replaceAll(
      "+",
      " ")?.
      replaceAll("%2C", ",");
      setCheckRadioLoc(queryparams?.City ? JSON.parse(cityQueryParam) : []);

      //region
      const regionQueryParam = queryparams?.Region?.replaceAll(
      "+",
      " ")?.
      replaceAll("%2C", ",");
      setCheckRadioRegion(
      queryparams?.Region ? JSON.parse(regionQueryParam) : []);


      //region
      const skillQueryParam = queryparams?.Skill?.replaceAll(
      "+",
      " ")?.
      replaceAll("%2C", ",");
      setCheckRadioSkill(queryparams?.Skill ? JSON.parse(decodeSpecialCharacter(skillQueryParam)) : []);
      setCheckRadioIndustry(
      queryparams?.Industry ? JSON.parse(queryParams.get("Industry")) : []);

      setCheckIndustryId(
      queryparams?.industryId ? JSON.parse(queryParams.get("industryId")) : []);


      //state
      const stateQueryParam = queryparams?.Country?.replaceAll(
      "+",
      " ")?.
      replaceAll("%2C", ",");
      setCheckRadioCountry(
      queryparams?.Country ? JSON.parse(stateQueryParam) : []);

      setCheckRadioVisaName(
      queryparams?.VisaName ? JSON.parse(queryparams.VisaName) : []);


      setSearchFilters({
        ...searchFilters,
        location:
        queryparams.City !== undefined ?
        searchFilters?.location?.length > 0 ?
        searchFilters.location :
        queryparams.City ?
        JSON.parse(queryparams.City) :
        [] :
        [],
        region: queryparams?.Country ? JSON.parse(queryparams?.Country) : [],
        state:
        queryparams.Region !== undefined ?
        searchFilters?.state?.length > 0 ?
        searchFilters.state :
        queryparams.Region ?
        JSON.parse(queryparams.Region) :
        [] :
        [],
        cityId: queryparams?.cityId ?
        JSON.parse(queryparams.cityId?.replaceAll("+", "")) :
        [],
        regionId: queryparams?.regionId ? JSON.parse(queryparams.regionId) : [],
        skillsId: queryparams?.skillsId ? JSON.parse(decodeSpecialCharacter(queryparams.skillsId)) : [],
        countryId: queryparams?.countryId ?
        JSON.parse(queryparams.countryId) :
        [],
        company:
        queryparams?.Company?.replace(/-\*/g, "&").replaceAll("+", " ") ??
        null,
        visa: queryparams?.VisaStatusId ?
        JSON.parse(queryparams.VisaStatusId) :
        [],
        visaName: queryparams?.VisaName ? JSON.parse(queryparams.VisaName) : [],
        industry: queryparams?.Industry ?
        JSON.parse(queryParams.get("Industry")) :
        [],
        industryId: queryparams?.industryId ?
        JSON.parse(queryParams.get("industryId") || []) :
        [],

        skill: queryparams?.Skill ? JSON.parse(decodeSpecialCharacter(queryparams.Skill)) : [],
        skillListing_type:
        url?.search?.
        split("skillListing_type=")[1]?.
        split("&")[0]?.
        replaceAll("+", " ")?.
        replaceAll("%2C", ",") ?? null,
        isPrivateTalent: [true, "true"].includes(
        url?.search?.split("isPrivateTalent=")[1]?.split("&")[0]),

        budgetType: url.search?.split("budgetType=")[1]?.split("&")[0] ?? null,
        ExperienceLevel: queryparams?.experience ?
        JSON.parse(queryparams?.experience?.replaceAll("+", " ")) :
        [],
        budgetMin: url.search?.split("budgetMin=")[1]?.split("&")[0] ?? null,
        budgetMax: url.search?.split("budgetMax=")[1]?.split("&")[0] ?? null,
        NearBy: url.search?.split("nearby=")[1] ? true : null,
        hidePrevious: url.search.split("hide=")[1]?.split("&")[0] ?? null,
        ProfessionCode:
        url.search.split("ProfessionCode=")[1]?.split("&")[0] ?? null
      });

      setCheckRadioCompany(
      queryparams?.Company ?
      queryparams?.Company?.replace(/-\*/g, "&").replaceAll("+", " ") :
      null);


      const obj = {
        ...getPrivateParams(),
        _page: 1,
        _perPage: perPage,
        search: searchKeyword ?? "",
        _sort:
        url?.search?.
        split("&")?.
        find((param) => param.includes("sortType="))?.
        split("sortType=")[1]?.
        split("&")[0] ?? "MOST_RELEVANT",
        NearBy: url.search?.split("nearby=")[1] ? true : null,
        Latitude: localStorage.getItem("latitude") ?
        localStorage.getItem("latitude").toString() :
        null,
        Longitude: localStorage.getItem("longitude") ?
        localStorage.getItem("longitude").toString() :
        null,
        maxDistance: "50",
        hide: url.search.split("hide=")[1]?.split("&")[0] ?? null,
        BudgetMax: url.search?.split("budgetMax=")[1]?.split("&")[0] ?? null,
        BudgetMin: url.search?.split("budgetMin=")[1]?.split("&")[0] ?? null,
        BudgetType: url.search?.split("budgetType=")[1]?.split("&")[0] ?? null,
        GigType:
        url?.search?.
        split("skillListing_type=")[1]?.
        split("&")[0]?.
        replaceAll("+", " ")?.
        replaceAll("%2C", ",") ?? null,
        CityId: queryparams.cityId ?
        JSON.parse(queryparams.cityId?.replaceAll("+", "")) :
        [],
        RegionId: queryparams.regionId ? JSON.parse(queryparams.regionId) : [],
        SkillsId: queryparams.skillsId ? JSON.parse(decodeSpecialCharacter(queryparams.skillsId)) : [],
        CountryId: queryparams.countryId ?
        JSON.parse(queryparams.countryId) :
        [],
        ProfessionCode:
        url.search.split("ProfessionCode=")[1]?.split("&")[0] ?? null,
        Experience: queryparams?.experience ?
        JSON.parse(queryparams?.experience?.replaceAll("+", " ")) :
        [],
        searchType: searchType,
        VisaStatusId: queryparams.VisaStatusId ?
        JSON.parse(queryparams.VisaStatusId) :
        [],
        Company: queryparams.Company ? queryparams.Company : null
      };
      const params = { obj };
      dispatch(skillListingCount(params));
      dispatch(getCandidatesCount(params));
      dispatch(skillListingTotalCount(params));
    } else {
      setSearchFilters({
        ...searchFilters,
        location: [],
        region: [],
        state: [],
        cityId: [],
        regionId: [],
        skillsId: [],
        countryId: [],
        visa: [],
        company: null,
        industry: [],
        industryId: [],
        skill: null,
        skillListing_type: null,
        budgetType: null,
        ExperienceLevel: [],
        budgetMin: null,
        budgetMax: null,
        NearBy: null,
        hidePrevious: null,
        ProfessionCode: null,
        isPrivateTalent: undefined
      });
      setBudget({
        budgetMax: null,
        budgetMin: null,
        budgetType: null
      });
      setPageNo(1);
      setCurrentPage(1);
      setcheckAllClicked(false);
      setSelectText(true);
      setProfessionSelected("All");
      setHideCheck(null);
      setCheckRadioLoc([]);
      setCheckLocObject(null);
      setCheckRadioRegion([]);
      setCheckRadioSkill([]);
      setCheckRegionObject(null);
      setCheckRadioCountry([]);
      setCheckCountryObject(null);
      setCheckRegionId([]);
      setCheckSkillId([]);
      setCheckIndustryId([]);
      setCheckCountryId([]);
      setCheckCityId([]);
      setJobTypeRadios(null);
      setcandidateTypeRadio(null);

      handleCityChange();
      handleRegionChange();
      handleCountryChange();
      handleSkillChange();
      setSortType("MOST_RELEVANT");
      setsortTypeText("Most relevant");
      setCheckRadio(null);
      setCheckedBox([]);

      const obj = {
        ...getPrivateParams(),
        _page: 1,
        _perPage: perPage,
        search: searchKeyword ?? "",
        _sort: sortType,
        NearBy: null,
        Latitude: localStorage.getItem("latitude") ?
        localStorage.getItem("latitude").toString() :
        null,
        Longitude: localStorage.getItem("longitude") ?
        localStorage.getItem("longitude").toString() :
        null,
        maxDistance: "50",
        hide: null,
        BudgetMax: null,
        BudgetMin: null,
        BudgetType: null,
        GigType: null,
        CityId: [],
        RegionId: [],
        SkillsId: [],
        CountryId: [],
        // Location: null,
        Experience: [],
        searchType: searchType
      };
      const params = { obj };
      dispatch(skillListingCount(params));
      dispatch(skillListingTotalCount(params));
    }
  }, [url.search, url.pathname, searchType]);

  useEffect(() => {
    if (props.searchIconClicked == true) {
      setEmptyCityInput("");
      setEmptyCountryInput("");
      setEmptyPrevIndustryInput("");
      setEmptyCompanyInput("");
      setEmptyRegionInput("");

      dispatch(ClearSearchIconClicked());
    }
  }, [props.searchIconClicked]);

  useEffect(() => {
    if (windowDimensions.width < 769) {
      setPerPage("20");
    } else {
      setPerPage("24");
    }
  }, [windowDimensions.width]);

  const query = gql`
        query{
          skilllistings(
            _sort: ${sortType},
            _page: ${pageNo},
            _perPage: ${perPage},
            accountId: ${userProfile?.AccountId || null},
            AbsPrivateTalent: ${
  Boolean(queryparams?.isPrivate) ||
  Boolean(searchFilters?.isPrivateTalent) ||
  false
  },
            GigType: "${searchFilters.skillListing_type ?? null}",
            CityId: ${JSON.stringify(searchFilters?.cityId)},
            RegionId:${JSON.stringify(searchFilters?.regionId)},
            SkillsId: ${JSON.stringify(searchFilters?.skillsId)},
            CountryId:${JSON.stringify(searchFilters?.countryId)},
            VisaStatusId: ${JSON.stringify(searchFilters?.visa)},
            IndustryName:${JSON.stringify(searchFilters.industryId)},
           
            CompanyName: "${
  searchFilters.company ?
  searchFilters.company?.
  replaceAll("+", " ")?.
  replaceAll("-*", "&") :
  null
  }",
            search: "${
  props.value ?
  props.value?.replaceAll('"', "")?.trim() || "" :
  searcheyword?.replaceAll('"', "")?.trim() || ""
  }",
            BudgetMin : "${searchFilters?.budgetMin ?? null}",
            BudgetMax : "${searchFilters?.budgetMax ?? null}",
            BudgetType : "${searchFilters?.budgetType ?? null}",
            Experience: ${JSON.stringify(searchFilters?.ExperienceLevel)},
            NearBy : "${searchFilters?.NearBy ?? null}",
            Latitude : "${latitude}",
            Longitude : "${longitude}",
            maxDistance : "50", 
            hide: ${searchFilters.hidePrevious},
            skillsPercentages: ${queryParams.get("skillsPercentages")},
            searchType: ${searchType},
            Authorization : "${token ? token.authToken : null}",
            ProfessionCode :"${
  searchFilters?.ProfessionCode ??
  userProfile?.Professions?.ProfessionCode ??
  null
  }",
            ) {
            aggregate {
              count
              totalCount
            }
            gigCount{
              title
             count
         }
          experienceCount{
              title
             count
          }     
          data {
            SkillListingId
              Title
              Description
              MinimumBid
              CreatedBy
              ModifiedBy
              bidstatus
              prevviewed
              Rating
              Review
              TotalCount{
                count{total}
              }
              BudgetTypes{

                BudgetTypeName
      
              }
              MinimumBid
              ClientRate
              JobOrderTypes{JobOrderTypeName}
              explevel{
                ExperienceLevelName
              }
              users {UserName,EmailAddress,MobilePhone,EmployeeAssociation,LastSuccessfulLoginDate,LastLoginDate,Profiles{
                FirstName,
                LastName,
                Rating,
                Review,  PictureUrl, LastLoginDate,
             ExperienceLevels{
              ExperienceLevelName
          }}}
            }
          }
        }
      `;
  // Rating,
  const [hitQuery, { loading, error, data }] = useLazyQuery(query);

  useEffect(() => {
    props.searchResponse(data);
  }, [data, props.value, loading]);

  useEffect(() => {
    if (!props.job_title) {
      dispatch(SearchValue(searcheyword));
    }
    debounce(hitQuery());
    setsortTypeText(
    url?.search?.
    split("&")?.
    find((param) => param.includes("sortType="))?.
    split("sortType=")[1]?.
    split("&")[0] == "MOST_RECENT" ?
    "New skill listing" :
    url?.search?.
    split("&")?.
    find((param) => param.includes("sortType="))?.
    split("sortType=")[1]?.
    split("&")[0] == "MOST_RELEVANT" ?
    "Most Relevant" :
    url?.search?.
    split("&")?.
    find((param) => param.includes("sortType="))?.
    split("sortType=")[1]?.
    split("&")[0] == "MOST_NEWEST" ?
    "Last Active" :
    url?.search?.
    split("&")?.
    find((param) => param.includes("sortType="))?.
    split("sortType=")[1]?.
    split("&")[0] == "RATINGS_HIGH_TO_LOW" ?
    "Ratings High to Low" :
    url?.search?.
    split("&")?.
    find((param) => param.includes("sortType="))?.
    split("sortType=")[1]?.
    split("&")[0] == "RATINGS_LOW_TO_HIGH" ?
    "Ratings Low to High" :
    url?.search?.
    split("&")?.
    find((param) => param.includes("sortType="))?.
    split("sortType=")[1]?.
    split("&")[0] == "PAY_HI_TO_LOW" ?
    "Desired Rate High to Low" :
    url?.search?.
    split("&")?.
    find((param) => param.includes("sortType="))?.
    split("sortType=")[1]?.
    split("&")[0] == "PAY_LOW_TO_HI" ?
    "Desired Rate Low to High" :
    "Most Relevant");

    getFilterCount();
  }, [searcheyword, pageNo]);

  //Get filters
  useEffect(() => {
    dispatch(GetFilters());
  }, []);

  useEffect(() => {
    if (Object.keys(searchLocationFilter)?.length && !props.job_title) {
      const params = {
        body: searchLocationFilter
      };
      dispatch(fetchKeySearchDynamicLocation(params));
    } else if (props.job_title && queryparams.City) {
      let countryDetail = JSON.parse(queryparams.City);
      let obj = defaultemptyObj;
      let param = { obj };
      let query;
      if (countryDetail.length > 0) {
        query = `location=${countryDetail[0].name}`;
      }
      let params = {
        value: query,
        body: param
      };
      dispatch(fetchKeySearchDynamicLocation(params));
    } else if (Object.keys(searchLocationFilter)?.length) {
      const params = {
        body: searchLocationFilter
      };
      dispatch(fetchKeySearchDynamicLocation(params));
    }
  }, [searchLocationFilter]);

  useEffect(() => {
    if (Object.keys(searchLocationFilter).length) {
      const params = {
        body: searchLocationFilter
      };
      dispatch(fetchKeySearchCompanyAndIndustries(params));
    }
  }, [searchLocationFilter]);

  useEffect(() => {
    if (Object.keys(searchLocationFilter).length) {
      const params = {
        body: searchLocationFilter
      };
      dispatch(fetchKeySearchSkills(params));
    }
  }, [searchLocationFilter]);

  useEffect(() => {
    // saving loading state to reducer from graphQL
    if (props.value?.length > 0) {
      props.SearchResponseRequested(loading);
    }
  }, [loading]);

  useEffect(() => {
    setGigs(props.skillListings.length ? data : data);

    setGqlError(error);
  }, [props.skillListings]);

  useEffect(() => {
    const filledFilterCount = Object.keys(searchFilters).filter((key) => {
      const value = searchFilters[key];
      if (
      key === "location" ||
      key === "region" ||
      key === "state" ||
      key === "budgetMin" ||
      key === "budgetMax" ||
      key === "visaName" ||
      key === "ProfessionCode" ||
      key === "skill")
      {
        return false; // Exclude specific properties
      } else {
        if (value === null) {
          return false; // Exclude null values
        } else if (Array.isArray(value)) {
          if (value.length == 0) {
            return false;
          } else {
            return value.length > 0;
          }
        }
        return true;
      }
    }).length;
    setFilterCount(filledFilterCount.toString());
  }, [searchFilters]);

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height
    };
  }

  const clearAllFunction = () => {
    if (
    searchFilters.ExperienceLevel.length ||
    searchFilters.location ||
    searchFilters.region ||
    searchFilters.state ||
    searchFilters.skillListing_type ||
    searchFilters.skill ||
    searchFilters.budgetMax &&
    searchFilters.budgetMin &&
    searchFilters.budgetType)
    {
      const obj = {
        ...getPrivateParams(),
        isPrivateTalent: undefined,
        _page: 1,
        _perPage: perPage,
        _sort: sortType,
        search:
        props.value === 0 ?
        "" :
        props.job_title ?
        props.job_title.join("$") :
        props.value,

        NearBy: null,
        Latitude: localStorage.getItem("latitude") ?
        localStorage.getItem("latitude").toString() :
        null,
        Longitude: localStorage.getItem("longitude") ?
        localStorage.getItem("longitude").toString() :
        null,
        maxDistance: "50",
        hide: null,
        BudgetMax: null,
        BudgetMin: null,
        BudgetType: null,
        GigType: null,
        GigType: null,
        CityId: [],
        RegionId: [],
        SkillsId: [],
        CountryId: [],
        Location: [],
        Experience: [],
        visa: [],
        visaName: [],
        hide: null,
        searchType: searchType,
        skill: [],
        SkillsId: searchFilters?.skillsId,
        VisaStatusId: searchFilters?.visa,
        CompanyName: searchFilters.company ? searchFilters.company : null
      };
      const params = { obj };
      const params1 = {
        body: searchLocationFilter
      };
      dispatch(getCandidatesCount(params));
      dispatch(skillListingCount(params));
      dispatch(skillListingTotalCount(params));
      dispatch(fetchKeySearchSkills(params));
      dispatch(fetchKeySearchDynamicLocation(params1));
    }
    setFilterError("");
    setIsFormOpen(false);
    setJobTypeRadios(null);
    setcandidateTypeRadio(null);
    setCheckRadio(null);
    setCheckedBox([]);
    setCheckRadioLoc([]);
    setCheckRadioVisa([]);
    setCheckLocObject("");
    setCheckRadioVisaName([]);
    setCheckRadioRegion([]);
    setCheckRadioSkill([]);
    //for prev industry
    setCheckRadioIndustry([]);
    setEmptyPrevIndustryInput(null);
    //for company
    setCheckRadioCompany(null);
    setCheckRegionObject("");
    setCheckRadioCountry([]);
    setCheckCountryObject("");
    setCheckCityId([]);
    setCheckRegionId([]);
    setCheckSkillId([]);
    setCheckIndustryId([]);
    setCheckCountryId([]);
    setClearForm(true);
    setHideCheck(false);
    setBudget({ budgetMax: null, budgetMin: null, budgetType: null });
    setSearchFilters({
      ...searchFilters,
      location: [],
      city: null,
      region: null,
      state: [],
      cityId: null,
      regionId: null,
      skill: [],
      skillsId: null,
      countryId: null,
      skillListing_type: null,
      budgetType: null,
      ExperienceLevel: [],
      visa: [],
      visaName: [],
      budgetMin: null,
      budgetMax: null,
      hidePrevious: null,
      ProfessionCode: null
    });

    setFilterCount(0);
    // removeQuery("location");
    removeQuery("City");
    removeQuery("Region");
    removeQuery("Country");
    removeQuery("skillListing_type");
    removeQuery("experience");
    removeQuery("budgetMax");
    removeQuery("budgetMin");
    removeQuery("budgetType");
    removeQuery("cityId");
    removeQuery("VisaStatusId");
    removeQuery("regionId");
    removeQuery("skillsId");
    removeQuery("countryId");
    removeQuery("pageNo");
    setEmptyCityInput("");
    setEmptyCountryInput("");
    setEmptyPrevIndustryInput("");
    setEmptyCompanyInput("");
    setEmptyRegionInput("");
    setEmptySkillInput("");
    setProfessionSelected("All");
    removeQuery("ProfessionCode");
    removeQuery("Company");
    removeQuery("Industry");
    removeQuery("VisaStatusId");
    removeQuery("VisaName");
    setCheckSkillObject(null);
    setCheckIndustryObject(null);
    removeQuery("Skill");
    setEmptySkillInput("");
    if (searchType === TAL_AUTO_SUGGESTED) {
      removeQuery("skillsPercentages");
      removeQuery("searchType");
      setSearchType("Skills");
    }
  };

  const clearFilter = (type) => {
    setIsFormOpen(false);
    setVisible(false);
    setCloseModalExp(false);
    setCloseModalSkill(false);
    setCloseModalLoc(false);
    setCloseModalRegion(false);
    setCloseModalState(false);
    setCloseModalBudget(false);
    setCloseModalCompany(false);
    setCloseModalVisa(false);
    setCloseModalPrev(false);
    if (
    searchFilters.ExperienceLevel.length && type == "experience" ||
    searchFilters.location.length && type == "city" ||
    // (searchFilters.city && type == "city") ||
    searchFilters.region && type == "region" ||
    searchFilters.state && type == "country" ||
    type == "industry" ||
    type == "company" ||
    searchFilters.skillListing_type && type == "jobType" ||
    searchFilters.budgetMax &&
    searchFilters.budgetMin &&
    searchFilters.budgetType &&
    type == "budget")
    {
      const obj = {
        ...getPrivateParams(),
        _page: 1,
        _perPage: perPage,
        _sort: sortType,
        search:
        props.value === 0 ?
        "" :
        props.job_title ?
        props.job_title.join("$") :
        props.value,
        BudgetMax: type === "budget" ? null : budget.budgetMax,
        BudgetMin: type === "budget" ? null : budget.budgetMin,
        BudgetType: type === "budget" ? null : budget.budgetType,
        GigType: type == "jobType" ? null : searchFilters.skillListing_type,
        NearBy: null,
        Latitude: localStorage.getItem("latitude") ?
        localStorage.getItem("latitude").toString() :
        null,
        Longitude: localStorage.getItem("longitude") ?
        localStorage.getItem("longitude").toString() :
        null,
        maxDistance: "50",
        hide: null,

        CityId: type == "city" ? [] : searchFilters.cityId,
        RegionId: type == "region" ? [] : searchFilters.regionId,
        CountryId: type == "country" ? [] : searchFilters.countryId,
        SkillsId: type == "skill" ? [] : searchFilters.skillsId,
        Experience: type == "experience" ? [] : searchFilters.ExperienceLevel,
        searchType: searchType,
        SkillsId: searchFilters?.skillsId,
        VisaStatusId: searchFilters?.visa,
        CompanyName: searchFilters.company ? searchFilters.company : null
      };
      const params = { obj };
      const params1 = {
        body: searchLocationFilter
      };
      dispatch(getCandidatesCount(params));
      dispatch(skillListingCount(params));
      dispatch(skillListingTotalCount(params));
      dispatch(fetchKeySearchDynamicLocation(params1));
      dispatch(fetchKeySearchCompanyAndIndustries(params1));
    }

    if (searchFilters.ExperienceLevel && type == "experience") {
      setSearchFilters({ ...searchFilters, ExperienceLevel: [] });
      setCheckRadio(null);
      setCheckedBox([]);
      setFilter({ ExperienceLevel: [] });
      removeQuery("experience");
    }
    if (checkRadio && type == "experience") {
      setCheckedBox([]);
      setCheckRadio(null);
    }
    if (searchFilters.location.length && type == "city") {
      setSearchFilters({
        ...searchFilters,
        location: [],
        cityId: null
      });
      setCheckRadioLoc([]);
      setCheckLocObject(null);
      removeQuery("City");
      setCheckCityId([]);
      setFilter({ location: null, cityId: null });
      removeQuery("cityId");

      setEmptyCityInput("");
    }

    if (searchFilters.ProfessionCode && type == "profession") {
      setSearchFilters({ ...searchFilters, ProfessionCode: null });
      setProfessionSelected("All");
      setFilter({ ProfessionCode: null });
      removeQuery("ProfessionCode");
      setProfessionDropdownOpen(false);
    }

    if (searchFilters.region && type == "region") {
      setSearchFilters({
        ...searchFilters,
        region: [],
        regionId: null
      });
      setCheckRadioRegion([]);
      setCheckRegionObject(null);
      removeQuery("Region");
      setCheckRegionId([]);
      setFilter({ regionId: [], state: [] });
      removeQuery("regionId");
      setEmptyRegionInput("");
    }
    //state
    if (searchFilters.state && type == "country") {
      setSearchFilters({
        ...searchFilters,
        state: [],
        countryId: null
      });
      setCheckRadioCountry([]);
      setCheckCountryObject(null);
      removeQuery("Country");
      setCheckCountryId([]);
      setFilter({ countryId: [], region: [] });
      removeQuery("countryId");
      setEmptyCountryInput("");
    }

    //skill
    if (searchFilters.skill && type == "skill") {
      setSearchFilters({
        ...searchFilters,
        skill: [],
        skillsId: null
      });
      setCheckRadioSkill([]);
      setCheckSkillObject(null);
      removeQuery("Skill");
      setCheckSkillId([]);
      setFilter({ skillsId: [], skill: [] });
      removeQuery("skillsId");
    }
    if (searchFilters.industry && type == "industry") {
      setSearchFilters({
        ...searchFilters,
        industry: [],
        industryId: []
      });
      setCheckIndustryObject(null);
      setCheckRadioIndustry([]);
      setCheckIndustryId([]);
      setFilter({ industryId: [], industry: [] });
      setPrevIndustryObj(null);
      removeQuery("Industry");
      removeQuery("industryId");
      setEmptyIndustryInput("");
      setEmptyPrevIndustryInput("");
    }

    //*********** */
    if (
    checkRadioLoc && type == "city" ||
    emptyCityInput == undefined && type == "city")
    {
      //
      setCheckRadioLoc([]);
      setCheckLocObject(null);
      setCheckCityId([]);
      setEmptyCityInput("");
    }

    // region
    if (
    checkRadioRegion && type == "region" ||
    emptyRegionInput == undefined && type == "region")
    {
      setCheckRadioRegion([]);
      setCheckRegionObject(null);
      setCheckRegionId([]);
      setEmptyRegionInput("");
    }

    // state
    if (
    checkRadioCountry && type == "country" ||
    emptyCountryInput == undefined && type == "country")
    {
      setCheckRadioCountry([]);
      setCheckCountryObject(null);
      setCheckCountryId([]);
      setEmptyCountryInput("");
    }

    // Previous Industry
    if (
    type == "industry" ||
    emptyPrevIndustryInput == undefined && type == "industry")
    {
      setPrevIndustryObj(null);
      setEmptyIndustryInput("");
      setEmptyPrevIndustryInput("");
    }
    //************* */
    if (searchFilters.skillListing_type && type == "jobType") {
      setSearchFilters({ ...searchFilters, skillListing_type: null });
      setJobTypeRadios(null);
      setFilter({ skillListing_type: null });
      removeQuery("skillListing_type");
    }

    //*********** */
    if (jobTypeRadio && type == "jobType") {
      setJobTypeRadios(null);
    }
    if (searchFilters.isPrivateTalent && type == "isPrivateTalent") {
      setSearchFilters({ ...searchFilters, isPrivateTalent: undefined });
      setcandidateTypeRadio(false);
      setFilter({ isPrivateTalent: undefined });
      removeQuery("isPrivateTalent");
    }

    //*********** */
    if (candidateTypeRadio && type == "isPrivateTalent") {
      setcandidateTypeRadio(null);
    }

    if (searchFilters.visa && type == "visa") {
      setSearchFilters({ ...searchFilters, visa: null });
      setSearchFilters({ ...searchFilters, visaName: null });
      setCheckRadioVisa([]);
      setFilter({ visa: [] });
      removeQuery("VisaStatusId");
      removeQuery("VisaName");
    }

    if (checkRadioVisa && type == "visa") {
      setCheckRadioVisa([]);
      setCheckRadioVisaName([]);
    }

    if (searchFilters.company && type == "company") {
      setSearchFilters({ ...searchFilters, company: null });
      setCheckRadioCompany(null);
      setFilter({ company: null });
      removeQuery("Company");
      setEmptyCompanyInput("");
    }

    if (checkRadioCompany && type == "company") {
      setCheckRadioCompany(null);
    }

    if (
    type == "company" ||
    emptyCompanyInput == undefined && type == "company")
    {
      setEmptyCompanyInput("");
    }

    if (searchFilters.industry && type == "industry") {
      setSearchFilters({ ...searchFilters, industry: [] });
      setCheckRadioIndustry([]);
      setFilter({ industry: [] });
      removeQuery("Industry");
      removeQuery("industryId");
    }

    if (checkRadioIndustry && type == "industry") {
      setCheckRadioIndustry([]);
      setCheckIndustryId([]);
    }

    if (
    (searchFilters.budgetMax ||
    searchFilters.budgetMin ||
    searchFilters.budgetType) &&
    type === "budget")
    {
      setSearchFilters({
        ...searchFilters,
        budgetMax: null,
        budgetMin: null,
        budgetType: null
      });
      setBudget({ budgetMax: null, budgetMin: null, budgetType: null });
      setFilter({ budgetMax: null, budgetMin: null, budgetType: null });
      setFilterError("");
      setClearForm(true);
      removeQuery("budgetMax");
      removeQuery("budgetMin");
      removeQuery("budgetType");
    }
    if (
    (budget.budgetMax || budget.budgetMin || budget.budgetType) &&
    type == "budget")
    {
      setBudget({ budgetMax: null, budgetMin: null, budgetType: null });
      setFilter({ budgetMax: null, budgetMin: null, budgetType: null });
      setClearForm(true);
    }
    if (searchType === TAL_AUTO_SUGGESTED) {
      removeQuery("skillsPercentages");
      removeQuery("searchType");
      setSearchType("Skills");
    }
  };

  // this button is same for all the desktop filters
  const ClearAll = ({ type }) => {
    return (
      <div className="clearAll-div">
        <div className="cancelfilter-btn" onClick={() => clearFilter(type)}>
          Clear all
        </div>
        <button
        className="applyfilter-btn"
        onClick={() => {
          applyFilters(type);
        }}>
          
          Apply
        </button>
      </div>);

  };

  const setFilter = (value) => {
    setSearchFilters(Object.assign(searchFilters, value));
    debounce(hitQuery());
    setPageNo(1);
    getFilterCount();
    setCurrentPage(1);
  };

  const addQuery = (key, value, action) => {
    let searchParams = new URLSearchParams(window.location.search);

    if (typeof value == "string") {
      let newSearch = value.replace(/&/g, "-*");
      searchParams.set(key, newSearch);
    } else {
      searchParams.set(key, value);
    }
    history.replace({
      search: searchParams.toString()
    });
  };

  const removeQuery = (key) => {
    let searchParams = new URLSearchParams(window.location.search);
    searchParams.delete(key);
    history.replace({
      search: searchParams.toString()
    });
  };

  const getFilterCount = () => {
    let count = 0;
    if (searchFilters.ExperienceLevel.length) {
      count++;
    }
    if (searchFilters.NearBy != null) {
      count++;
    }
    if (searchFilters.budgetMax != null) {
      count++;
    }
    if (searchFilters.budgetMin != null) {
      count++;
    }
    if (searchFilters.budgetType != null) {
      count++;
    }
    if (searchFilters?.location?.length) {
      count++;
    }
    if (searchFilters?.region?.length) {
      count++;
    }
    if (searchFilters?.state?.length) {
      count++;
    }
    if (searchFilters?.visa?.length) {
      count++;
    }
    if (searchFilters?.company != null) {
      count++;
    }
    if (searchFilters?.industry?.length) {
      count++;
    }
    if (searchFilters?.skillListing_type != null) {
      count++;
    }
    if (searchFilters?.hidePrevious != null) {
      count++;
    }
    if (searchFilters?.skill != null) {
      count++;
    }
    setFilterCount(count);
  };

  useEffect(() => {
    var options = [];
    if (filters && filters.location) {
      for (var i = 0; i < filters.location.length; i++) {
        options = [
        ...options,
        {
          value: filters.location[i].LocationWithCountry
        }];

      }
      setLocationValue(options);
    }
    setsortTypeText(
    url?.search?.
    split("&")?.
    find((param) => param.includes("sortType="))?.
    split("sortType=")[1]?.
    split("&")[0] == "MOST_RECENT" ?
    "New skill listing" :
    url?.search?.
    split("&")?.
    find((param) => param.includes("sortType="))?.
    split("sortType=")[1]?.
    split("&")[0] == "MOST_RELEVANT" ?
    "Most Relevant" :
    url?.search?.
    split("&")?.
    find((param) => param.includes("sortType="))?.
    split("sortType=")[1]?.
    split("&")[0] == "MOST_NEWEST" ?
    "Last Active" :
    url?.search?.
    split("&")?.
    find((param) => param.includes("sortType="))?.
    split("sortType=")[1]?.
    split("&")[0] == "RATINGS_HIGH_TO_LOW" ?
    "Ratings High to Low" :
    url?.search?.
    split("&")?.
    find((param) => param.includes("sortType="))?.
    split("sortType=")[1]?.
    split("&")[0] == "RATINGS_LOW_TO_HIGH" ?
    "Ratings Low to High" :
    url?.search?.
    split("&")?.
    find((param) => param.includes("sortType="))?.
    split("sortType=")[1]?.
    split("&")[0] == "PAY_HI_TO_LOW" ?
    "Desired Rate High to Low" :
    url?.search?.
    split("&")?.
    find((param) => param.includes("sortType="))?.
    split("sortType=")[1]?.
    split("&")[0] == "PAY_LOW_TO_HI" ?
    "Desired Rate Low to High" :
    "Most Relevant");

  }, [props.value, filters]);

  const setJobType = (e) => {
    setJobTypeRadios(e.target.value);
  };
  const setCandidateType = (e) => {
    setcandidateTypeRadio(e.target.value);
  };

  const onSearch = (e) => {
    props.searchValue(e);
    setBudget({ budgetMax: null, budgetMin: null, budgetType: null });
    setJobTypeRadios(null);
    setcandidateTypeRadio(null);
    setCheckRadio(null);
    setCheckedBox([]);
    setCheckRadioLoc([]);
    setCheckCityId([]);
    setCheckLocObject(null);
    setHideCheck(null);
    setCheckRegionId([]);
    removeQuery("location");
    removeQuery("City");
    removeQuery("Region");
    removeQuery("State");
    removeQuery("city");
    removeQuery("pageNo");
    removeQuery("region");
    removeQuery("budgetMax");
    removeQuery("budgetMin");
    removeQuery("budgetType");
    removeQuery("skillListing_type");
    removeQuery("experience");
    removeQuery("hide");
    removeQuery("VisaStatusId");
    removeQuery("VisaName");
    setClearSort(true);

    setSearchFilters({
      location: [],
      state: [],
      cityId: null,
      regionId: null,
      skillListing_type: null,
      budgetType: null,
      ExperienceLevel: [],
      budgetMin: null,
      budgetMax: null,
      NearBy: null,
      hidePrevious: null,
      visa: [],
      visaName: []
    });

    localStorage.setItem("search", e);
    history.push(`/query/${e?.replace(/\//g, "%2F")}`);
  };

  const CandidateMenu =
  <Menu
  className={`skill-type-menu ${
  filterError === "isPrivateTalent" && "filterError"
  }`}>
    
      <div style={{ width: "100%", marginBottom: "20px" }}>
        <Radio.Group
      value={candidateTypeRadio || false}
      onChange={(e) => {
        setCandidateType(e);
        setFilterError("");
        applyFilters("isPrivateTalent", e?.target?.value);
      }}
      style={{ width: "inherit" }}
      className="space radio-color ">
        
          <Space
        style={{ width: "inherit", rowGap: "16px" }}
        direction="vertical">
          
            <Radio style={{ width: "inherit" }} value={false}>
              <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "inherit"
            }}>
              
                <div>All candidates</div>
                <div style={{ color: "#7e7e7e" }}></div>
              </div>
            </Radio>
            <Radio style={{ width: "inherit" }} value={true}>
              <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "inherit"
            }}>
              
                <div>Private candidates</div>{" "}
                <div style={{ color: "#7e7e7e" }}></div>
              </div>
            </Radio>
          </Space>
        </Radio.Group>
      </div>
    </Menu>;


  const JobMenu =
  <Menu
  className={`skill-type-menu ${
  filterError === "jobtype" && "filterError"
  }`}>
    
      <div style={{ width: "100%", marginBottom: "20px" }}>
        <Radio.Group
      value={jobTypeRadio}
      onChange={(e) => {
        setJobType(e);
        setFilterError("");
      }}
      style={{ width: "inherit" }}
      className="space radio-color ">
        
          <Space
        style={{ width: "inherit", rowGap: "16px" }}
        direction="vertical">
          
            <Radio style={{ width: "inherit" }} value={"Contract"}>
              <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "inherit"
            }}>
              
                <div>Contract</div>
              </div>
            </Radio>
            <Radio style={{ width: "inherit" }} value={"Permanent"}>
              <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "inherit"
            }}>
              
                <div>Permanent</div>{" "}
              </div>
            </Radio>
            {isNonHC(userProfile?.Professions?.ProfessionCode) || isNonHC(
          professionSelected) ? null :
          <Radio
          style={{ width: "inherit" }}
          value={jobTypeRadio == "Per+Diem" ? jobTypeRadio : "Per Diem"}>
            
                <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "inherit",
              whiteSpace: "nowrap"
            }}>
              
                  <div>Per diem</div>{" "}
                </div>
              </Radio>}
          
          </Space>
        </Radio.Group>
      </div>
      {filterError === "jobtype" &&
    <div className="filter-error-style">
          Please select any of the job type
        </div>}
    
      <ClearAll type={"jobType"} />
    </Menu>;


  const experienceLevel =
  <Menu
  className={`experiecne-level-menu ${
  filterError === "experience" && "filterError"
  }`}>
    
      <ExperienceLevel
    totalCountError={Object.keys(totalCountError).length}
    gqlError={gqlError}
    setFilter={setFilter}
    setcheck={setCheckRadio}
    checkBox={checkBox}
    setCheckedBox={setCheckedBox}
    check={checkRadio}
    countCheck={props.job_title} />
    
      {!checkBox.length && filterError === "experience" &&
    <div className="filter-error-style">Please select experience level</div>}
    
      <div style={{ paddingRight: "5px" }}>
        <ClearAll type={"experience"} />
      </div>
    </Menu>;


  const BudgetMenu =
  <Menu className={`filter-menu-budget`}>
      <div
    className={`budget-filter-container ${
    filterError === "budget" && "filterError"
    }`}>
      
        <BudgetFilter
      setFilterError={setFilterError}
      setFilter={setFilter}
      Filter={searchFilters}
      budget={budget}
      setBudget={setBudget}
      clear={clearForm}
      setClear={setClearForm} />
      

        {filterError === "budget" ?
      <div className="filter-error-style">
            Please enter budget and budget type
          </div> :

      filterError === "selectBudget" &&
      <div className="filter-error-style">
              Please select both filters{" "}
            </div>}

      
        <ClearAll type={"budget"} />
      </div>
    </Menu>;


  const locationMenu =
  <Menu
  className={`location-filter-menu ${
  filterError === "city" && "filterError"
  }`}>
    
      <div className="location-filter-menu-inner">
        <FilterLocation
      closeModalLoc={closeModalLoc}
      setlocObj={setCheckLocObject}
      locObj={checkLocObject}
      setFilter={setFilter}
      setcheck={setCheckRadioLoc}
      check={checkRadioLoc}
      setCheckCityId={setCheckCityId}
      checkCityId={checkCityId}
      emptyCityInput={emptyCityInput}
      setEmptyCityInput={setEmptyCityInput}
      searchLocationFilter={searchLocationFilter}
      countCheck={props.job_title} />
      
        {checkRadioLoc?.length <= 0 && filterError === "city" &&
      <div className="filter-error-style">Please select city</div>}
      
        <div style={{ paddingRight: "5px" }}>
          <ClearAll type={"city"} />
        </div>
      </div>
    </Menu>;


  //region
  const RegionMenu =
  <Menu
  className={`location-filter-menu ${
  filterError === "region" && "filterError"
  }`}>
    
      <div className="location-filter-menu-inner">
        <FilterRegion
      setregionObj={setCheckRegionObject}
      regionObj={checkRegionObject}
      setcheck={setCheckRadioRegion}
      check={checkRadioRegion}
      setFilter={setFilter}
      setCheckRegionId={setCheckRegionId}
      checkRegionId={checkRegionId}
      addQuery={addQuery}
      emptyRegionInput={emptyRegionInput}
      setEmptyRegionInput={setEmptyRegionInput}
      searchLocationFilter={searchLocationFilter}
      countCheck={props.job_title} />
      
        {filterError === "region" && checkRadioRegion?.length <= 0 &&
      <div className="filter-error-style">Please select region</div>}
      
        <div style={{ paddingRight: "5px" }}>
          <ClearAll type="region" />
        </div>
      </div>
    </Menu>;


  //state
  const StateMenu =
  <Menu
  className={`location-filter-menu ${
  filterError === "country" && "filterError"
  }`}>
    
      <div className="location-filter-menu-inner">
        <FilterState
      setcountryObj={setCheckCountryObject}
      countryObj={checkCountryObject}
      setcheck={setCheckRadioCountry}
      check={checkRadioCountry}
      setFilter={setFilter}
      setCheckCountryId={setCheckCountryId}
      checkCountryId={checkCountryId}
      addQuery={addQuery}
      emptyCountryInput={emptyCountryInput}
      setEmptyCountryInput={setEmptyCountryInput}
      searchLocationFilter={searchLocationFilter}
      countCheck={props.job_title} />
      

        {filterError === "country" && checkRadioCountry?.length <= 0 &&
      <div className="filter-error-style">Please select country</div>}
      
        <div style={{ paddingRight: "5px" }}>
          <ClearAll type="country" />
        </div>
      </div>
    </Menu>;


  //skill
  const SkillMenu =
  <Menu
  className={`location-filter-menu ${
  filterError === "region" && "filterError"
  }`}>
    
      <div className="location-filter-menu-inner">
        <FilterSkill
      setskillObj={setCheckSkillObject}
      skillObj={checkSkillObject}
      setcheck={setCheckRadioSkill}
      check={checkRadioSkill}
      setFilter={setFilter}
      addQuery={addQuery}
      checkSkillId={checkSkillId}
      setCheckSkillId={setCheckSkillId}
      emptySkillInput={emptySkillInput}
      setEmptySkillInput={setEmptySkillInput}
      searchLocationFilter={searchLocationFilter}
      countCheck={props.job_title} />
      
        {filterError === "skill" && !checkRadioSkill &&
      <div className="filter-error-style">Please select a skill</div>}
      

        <ClearAll type="skill" />
      </div>
    </Menu>;


  //Company
  const CompanyMenu =
  <Menu
  className={`location-filter-menu ${
  filterError === "company" && "filterError"
  }`}>
    
      <div className="location-filter-menu-inner">
        <FilterCompany
      setcheck={setCheckRadioCompany}
      check={checkRadioCompany?.replaceAll("-*", "&")}
      setFilter={setFilter}
      addQuery={addQuery}
      emptyCompanyInput={emptyCompanyInput}
      setEmptyCompanyInput={setEmptyCompanyInput}
      searchLocationFilter={searchLocationFilter}
      countCheck={props.job_title} />
      
        {filterError === "company" && checkRadioCompany <= 0 &&
      <div className="filter-error-style">Please select Company</div>}
      
        <div style={{ paddingRight: "5px" }}>
          <ClearAll type={"company"} />
        </div>
      </div>
    </Menu>;


  //Visa
  const VisaMenu =
  <Menu
  className={`experiecne-level-menu-visa-statuses ${
  filterError === "visa" && "filterError"
  }`}>
    
      <FilterVisa
    setFilter={setFilter}
    checkBox={checkRadioVisaName}
    setCheckedBox={setCheckRadioVisaName}
    setRadioCheck={setCheckRadioVisa}
    checkRadio={checkRadioVisa}
    countCheck={props.job_title} />
    
      {!checkRadioVisa.length && filterError === "visa" &&
    <div className="filter-error-style">Please select any visa type</div>}
    
      <ClearAll type={"visa"} />
    </Menu>;


  //Prev
  const PrevMenu =
  <Menu
  className={`location-filter-menu ${
  filterError === "industry" && "filterError"
  }`}>
    
      <div className="location-filter-menu-inner">
        <FilterIndustry
      setIndustryObj={setCheckIndustryObject}
      industryObj={checkIndustryObject}
      setcheck={setCheckRadioIndustry}
      check={checkRadioIndustry}
      setFilter={setFilter}
      addQuery={addQuery}
      emptyIndustryInput={emptyIndustryInput}
      setEmptyIndustryInput={setEmptyIndustryInput}
      searchLocationFilter={searchLocationFilter}
      countCheck={props.job_title}
      checkIndustryId={checkIndustryId}
      setCheckIndustryId={setCheckIndustryId} />
      
        {filterError === "industry" && checkRadioIndustry <= 0 &&
      <div className="filter-error-style">Please select an Industry</div>}
      
        <div style={{ paddingRight: "5px" }}>
          <ClearAll type="industry" />
        </div>
      </div>
    </Menu>;


  const CountDetail = (props) => {
    return isTalentSuggestion ? null : !gqlError ?
    loading ?
    <p>Showing {<LoadingOutlined className="count-loader" />} items</p> :

    <p>
          Showing{" "}
          {searchType ?
      skillListings?.skilllistings?.data.length > 0 &&
      skillListings?.skilllistings?.data[0].TotalCount?.count ?
      skillListings?.skilllistings?.data[0].TotalCount?.count?.total :
      0 :
      ""}{" "}
          results for{" "}
          <strong style={{ textTransform: "capitalize" }}>
            {" "}
            "
            {props.value != "" ?
        props.value?.replaceAll('"', "")?.replaceAll("$", " ,") :
        searcheyword?.replaceAll("$", " ,")}
            "
          </strong>
        </p> :

    null;
  };

  useEffect(() => {
    if (skillListingIds?.length < 1) {
      setcheckAllClicked(false);
      setSelectText(true);
    }
  }, [skillListingIds]);

  const checkFiltervalidity = () => {
    if (
    !checkRadioLoc &&
    !checkRadioRegion &&
    !checkRadioCountry &&
    !jobTypeRadio &&
    !budget.budgetMax &&
    !budget.budgetMin &&
    !budget.budgetType &&
    //!checkRadio &&
    checkBox.length <= 0 &&
    !hideCheck &&
    !professionSelected &&
    isformOpen)
    {
      return true;
    } else return false;
  };

  const applyFilters = (type, value = null) => {
    setIsFormOpen(false);
    let canClose = true;
    setCurrentPage(1);
    if (searchType === TAL_AUTO_SUGGESTED) {
      removeQuery("skillsPercentages");
      removeQuery("searchType");
      setSearchType("Skills");
    }
    if (type !== "mobile") {
      if (type === "budget") {
        if (
        budget.budgetMax &&
        budget.budgetMin &&
        +budget.budgetMax > +budget.budgetMin &&
        budget.budgetType)
        {
          removeQuery("pageNo");
          setPageNo(1);
          setFilter({
            budgetMax: budget.budgetMax,
            budgetMin: budget.budgetMin,
            budgetType: budget.budgetType
          });
          addQuery("budgetMax", budget.budgetMax);
          addQuery("budgetMin", budget.budgetMin);
          addQuery("budgetType", budget.budgetType);
          setCloseModalBudget(false);
          setFilterError("");

          const obj = {
            ...getPrivateParams(),
            _page: 1,
            _perPage: perPage,
            _sort: sortType,
            search:
            props.value === 0 ?
            "" :
            props.job_title ?
            props.job_title.join("$") :
            props.value,

            NearBy: searchFilters.NearBy ? true : null,
            Latitude: localStorage.getItem("latitude") ?
            localStorage.getItem("latitude").toString() :
            null,
            Longitude: localStorage.getItem("longitude") ?
            localStorage.getItem("longitude").toString() :
            null,

            maxDistance: "50",
            hide: hideCheck ? true : null,

            BudgetMax: budget.budgetMax,
            BudgetMin: budget.budgetMin,
            BudgetType: budget.budgetType,
            GigType: jobTypeRadio,
            CityId: checkCityId,
            RegionId: checkRegionId,
            CountryId: checkCountryId,
            Experience: checkBox, //checkRadio,
            searchType: searchType,
            SkillsId: searchFilters?.skillsId,
            VisaStatusId: searchFilters?.visa,
            CompanyName: searchFilters.company ? searchFilters.company : null
          };
          const params = { obj };
          dispatch(skillListingCount(params));
          dispatch(getCandidatesCount(params));
          dispatch(skillListingTotalCount(params));
        } else {
          setFilter({ budgetMax: null, budgetMin: null, budgetType: null });
          setFilterError("budget");
        }
      }

      if (type === "jobType") {
        if (jobTypeRadio) {
          setPageNo(1);
          removeQuery("pageNo");
          setFilter({ skillListing_type: jobTypeRadio });
          setVisible(false);
          setCloseModalSkill(false);
          setFilterError("");
          addQuery("skillListing_type", jobTypeRadio);

          const obj = {
            ...getPrivateParams(),
            _page: 1,
            _perPage: perPage,
            _sort: sortType,
            search:
            props.value === 0 ?
            "" :
            props.job_title ?
            props.job_title.join("$") :
            props.value,

            NearBy: searchFilters.NearBy ? true : null,
            Latitude: localStorage.getItem("latitude") ?
            localStorage.getItem("latitude").toString() :
            null,
            Longitude: localStorage.getItem("longitude") ?
            localStorage.getItem("longitude").toString() :
            null,

            maxDistance: "50",
            hide: hideCheck ? true : null,

            BudgetMax: budget.budgetMax,
            BudgetMin: budget.budgetMin,
            BudgetType: budget.budgetType,
            GigType: jobTypeRadio,
            CityId: checkCityId,
            RegionId: checkRegionId,
            CountryId: checkCountryId,
            // Location: checkRadioLoc,
            Experience: checkBox, //checkRadio,
            searchType: searchType,
            SkillsId: searchFilters?.skillsId,
            VisaStatusId: searchFilters?.visa,
            CompanyName: searchFilters.company ? searchFilters.company : null
          };
          const params = { obj };
          dispatch(skillListingCount(params));
          dispatch(getCandidatesCount(params));
          dispatch(skillListingTotalCount(params));
        } else {
          setFilterError("jobtype");
        }
      }
      if (type === "isPrivateTalent") {
        setPageNo(1);
        removeQuery("pageNo");
        setFilter({ isPrivateTalent: Boolean(value) || undefined });
        setVisible(false);
        setCloseCandidateModal(false);
        setFilterError("");
        addQuery("isPrivateTalent", value);

        const obj = {
          ...getPrivateParams(),
          isPrivateTalent: Boolean(value) || undefined,
          _page: 1,
          _perPage: perPage,
          _sort: sortType,
          search:
          props.value === 0 ?
          "" :
          props.job_title ?
          props.job_title.join("$") :
          props.value,

          NearBy: searchFilters.NearBy ? true : null,
          Latitude: localStorage.getItem("latitude") ?
          localStorage.getItem("latitude").toString() :
          null,
          Longitude: localStorage.getItem("longitude") ?
          localStorage.getItem("longitude").toString() :
          null,

          maxDistance: "50",
          hide: hideCheck ? true : null,

          BudgetMax: budget.budgetMax,
          BudgetMin: budget.budgetMin,
          BudgetType: budget.budgetType,
          GigType: jobTypeRadio,
          CityId: checkCityId,
          RegionId: checkRegionId,
          CountryId: checkCountryId,
          Experience: checkBox, //checkRadio,
          searchType: searchType,
          SkillsId: searchFilters?.skillsId,
          VisaStatusId: searchFilters?.visa,
          CompanyName: searchFilters.company ? searchFilters.company : null
        };
        const params = { obj };
        dispatch(skillListingCount(params));
        dispatch(skillListingTotalCount(params));
        dispatch(getCandidatesCount(params));
      }

      if (type === "company") {
        if (checkRadioCompany) {
          removeQuery("pageNo");
          setPageNo(1);
          setFilter({ company: checkRadioCompany });
          setVisible(false);
          setCloseModalCompany(false);
          setFilterError("");
          addQuery("Company", checkRadioCompany);

          const obj = {
            ...getPrivateParams(),
            _page: 1,
            _perPage: perPage,
            _sort: sortType,
            search:
            props.value === 0 ?
            "" :
            props.job_title ?
            props.job_title.join("$") :
            props.value,

            NearBy: searchFilters.NearBy ? true : null,
            Latitude: localStorage.getItem("latitude") ?
            localStorage.getItem("latitude").toString() :
            null,
            Longitude: localStorage.getItem("longitude") ?
            localStorage.getItem("longitude").toString() :
            null,

            maxDistance: "50",
            hide: hideCheck ? true : null,

            BudgetMax: budget.budgetMax,
            BudgetMin: budget.budgetMin,
            BudgetType: budget.budgetType,
            GigType: jobTypeRadio,
            CityId: checkCityId,
            RegionId: checkRegionId,
            CountryId: checkCountryId,
            Experience: checkBox, //checkRadio,
            searchType: searchType,
            SkillsId: searchFilters?.skillsId,
            VisaStatusId: searchFilters?.visa,
            CompanyName: searchFilters.company ? searchFilters.company : null
          };
          const params = { obj };
          dispatch(skillListingCount(params));
          dispatch(skillListingTotalCount(params));
          dispatch(getCandidatesCount(params));
        } else {
          setFilterError("company");
        }
      }

      if (type === "industry") {
        if (checkRadioIndustry.length) {
          removeQuery("pageNo");
          setPageNo(1);
          setFilter({
            ...searchFilters,
            industry: checkRadioIndustry,
            industryId: checkIndustryId
          });
          // here
          setVisible(false);
          setCloseModalPrev(false);
          setFilterError("");
          addQuery("Industry", JSON.stringify(checkRadioIndustry));
          addQuery("industryId", JSON.stringify(checkIndustryId));
          const obj = {
            ...getPrivateParams(),
            _page: 1,
            _perPage: perPage,
            _sort: sortType,
            search:
            props.value === 0 ?
            "" :
            props.job_title ?
            props.job_title.join("$") :
            props.value,

            NearBy: searchFilters.NearBy ? true : null,
            Latitude: localStorage.getItem("latitude") ?
            localStorage.getItem("latitude").toString() :
            null,
            Longitude: localStorage.getItem("longitude") ?
            localStorage.getItem("longitude").toString() :
            null,

            maxDistance: "50",
            hide: hideCheck ? true : null,

            BudgetMax: budget.budgetMax,
            BudgetMin: budget.budgetMin,
            BudgetType: budget.budgetType,
            GigType: jobTypeRadio,
            CityId: checkCityId,
            RegionId: checkRegionId,
            CountryId: checkCountryId,
            Experience: checkBox,
            searchType: searchType,
            SkillsId: searchFilters?.skillsId,
            VisaStatusId: searchFilters?.visa,
            CompanyName: searchFilters.company ? searchFilters.company : null
          };
          const params = { obj };
          dispatch(getCandidatesCount(params));
        } else {
          setFilterError("industry");
        }
      }

      if (type === "skill") {
        if (checkRadioSkill.length) {
          removeQuery("pageNo");
          setPageNo(1);
          setFilter({
            ...searchFilters,
            skillsId: checkSkillId,
            skill: checkRadioSkill
          });
          setVisible(false);
          setCloseModalSkill1(false);
          setFilterError("");
          addQuery("Skill", JSON.stringify(checkRadioSkill));
          addQuery("skillsId", JSON.stringify(checkSkillId));
          const obj = {
            ...getPrivateParams(),
            _page: 1,
            _perPage: perPage,
            _sort: sortType,
            search:
            props.value === 0 ?
            "" :
            props.job_title ?
            props.job_title.join("$") :
            props.value,

            NearBy: searchFilters.NearBy ? true : null,
            Latitude: localStorage.getItem("latitude") ?
            localStorage.getItem("latitude").toString() :
            null,
            Longitude: localStorage.getItem("longitude") ?
            localStorage.getItem("longitude").toString() :
            null,

            maxDistance: "50",
            hide: hideCheck ? true : null,

            BudgetMax: budget.budgetMax,
            BudgetMin: budget.budgetMin,
            BudgetType: budget.budgetType,
            GigType: jobTypeRadio,
            CityId: checkCityId,
            RegionId: checkRegionId,
            CountryId: checkCountryId,
            // Location: checkRadioLoc,
            Experience: checkBox,
            searchType: searchType,
            SkillsId: searchFilters?.skillsId,
            VisaStatusId: searchFilters?.visa,
            CompanyName: searchFilters.company ? searchFilters.company : null
          };
          const params = { obj };
          dispatch(getCandidatesCount(params));
        } else {
          setFilterError("skill");
        }
      }

      if (type === "visa") {
        if (checkRadioVisa) {
          setPageNo(1);
          removeQuery("pageNo");
          setFilter({ visa: checkRadioVisa });
          setFilter({ visaName: checkRadioVisaName });
          setVisible(false);
          setCloseModalVisa(false);
          setFilterError("");
          addQuery("VisaStatusId", JSON.stringify(checkRadioVisa));
          addQuery("VisaName", JSON.stringify(checkRadioVisaName));
        } else {
          setFilterError("visa");
        }
      }

      if (type === "company") {
        if (checkRadioCompany) {
          removeQuery("pageNo");
          setPageNo(1);
          setFilter({ company: checkRadioCompany });
          setVisible(false);
          setCloseModalCompany(false);
          setFilterError("");
          addQuery("Company", checkRadioCompany);
          const obj = {
            ...getPrivateParams(),
            _page: 1,
            _perPage: perPage,
            _sort: sortType,
            search:
            props.value === 0 ?
            "" :
            props.job_title ?
            props.job_title.join("$") :
            props.value,

            NearBy: searchFilters.NearBy ? true : null,
            Latitude: localStorage.getItem("latitude") ?
            localStorage.getItem("latitude").toString() :
            null,
            Longitude: localStorage.getItem("longitude") ?
            localStorage.getItem("longitude").toString() :
            null,

            maxDistance: "50",
            hide: hideCheck ? true : null,
            BudgetMax: budget.budgetMax,
            BudgetMin: budget.budgetMin,
            BudgetType: budget.budgetType,
            GigType: jobTypeRadio,
            CityId: checkCityId,
            RegionId: checkRegionId,
            CountryId: checkCountryId,
            // Location: checkRadioLoc,
            Experience: checkBox,
            searchType: searchType,
            SkillsId: searchFilters?.skillsId,
            VisaStatusId: searchFilters?.visa,
            CompanyName: searchFilters.company ? searchFilters.company : null
          };
          const params = { obj };
          dispatch(getCandidatesCount(params));
        } else {
          setFilterError("company");
        }
      }

      if (type === "visa") {
        if (checkRadioVisa) {
          setPageNo(1);
          removeQuery("pageNo");
          setFilter({ visa: checkRadioVisa });
          setFilter({ visaName: checkRadioVisaName });
          setVisible(false);
          setCloseModalVisa(false);
          setFilterError("");
          addQuery("VisaStatusId", JSON.stringify(checkRadioVisa));
          addQuery("VisaName", JSON.stringify(checkRadioVisaName));
        } else {
          setFilterError("visa");
        }
      }

      if (type === "city") {
        if (checkRadioLoc.length) {
          removeQuery("pageNo");
          setPageNo(1);
          setSearchFilters({
            ...searchFilters,
            cityId: checkCityId,
            location: checkRadioLoc
          });
          setVisible(false);
          setCloseModalLoc(false);
          setFilterError("");
          addQuery("City", JSON.stringify(checkRadioLoc));
          addQuery("cityId", JSON.stringify(checkCityId));
          const obj = {
            ...getPrivateParams(),
            _page: 1,
            _perPage: perPage,
            _sort: sortType,
            search:
            props.value === 0 ?
            "" :
            props.job_title ?
            props.job_title.join("$") :
            props.value,

            NearBy: searchFilters.NearBy ? true : null,
            Latitude: localStorage.getItem("latitude") ?
            localStorage.getItem("latitude").toString() :
            null,
            Longitude: localStorage.getItem("longitude") ?
            localStorage.getItem("longitude").toString() :
            null,

            maxDistance: "50",
            hide: hideCheck ? true : null,

            BudgetMax: budget.budgetMax,
            BudgetMin: budget.budgetMin,
            BudgetType: budget.budgetType,
            GigType: jobTypeRadio,
            CityId: checkCityId,
            RegionId: checkRegionId,
            CountryId: checkCountryId,
            Experience: checkBox, //checkRadio
            searchType: searchType,
            SkillsId: searchFilters?.skillsId,
            VisaStatusId: searchFilters?.visa,
            CompanyName: searchFilters.company ? searchFilters.company : null
          };
          const params = { obj };
          dispatch(getCandidatesCount(params));
          dispatch(skillListingCount(params));
          dispatch(skillListingTotalCount(params));
        } else {
          setFilterError("city");
        }
      }

      //region
      if (type === "region") {
        if (checkRadioRegion.length) {
          removeQuery("pageNo");
          setPageNo(1);
          setSearchFilters({
            ...searchFilters,
            regionId: checkRegionId,
            state: checkRadioRegion
          });
          setVisible(false);
          setCloseModalRegion(false);
          setFilterError("");
          addQuery("Region", JSON.stringify(checkRadioRegion));
          addQuery("regionId", JSON.stringify(checkRegionId));
          const obj = {
            ...getPrivateParams(),
            _page: 1,
            _perPage: perPage,
            _sort: sortType,
            search:
            props.value === 0 ?
            "" :
            props.job_title ?
            props.job_title.join("$") :
            props.value,

            NearBy: searchFilters.NearBy ? true : null,
            Latitude: localStorage.getItem("latitude") ?
            localStorage.getItem("latitude").toString() :
            null,
            Longitude: localStorage.getItem("longitude") ?
            localStorage.getItem("longitude").toString() :
            null,

            maxDistance: "50",
            hide: hideCheck ? true : null,

            BudgetMax: budget.budgetMax,
            BudgetMin: budget.budgetMin,
            BudgetType: budget.budgetType,
            GigType: jobTypeRadio,
            CityId: checkCityId,
            RegionId: checkRegionId,
            CountryId: checkCountryId,
            Experience: checkBox, //checkRadio
            searchType: searchType,
            SkillsId: searchFilters?.skillsId,
            VisaStatusId: searchFilters?.visa,
            CompanyName: searchFilters.company ? searchFilters.company : null
          };
          const params = { obj };
          dispatch(getCandidatesCount(params));
          dispatch(skillListingCount(params));
          dispatch(skillListingTotalCount(params));
        } else {
          setFilterError("region");
        }
      }
      //state
      if (type === "country") {
        if (checkRadioCountry.length) {
          removeQuery("pageNo");
          setPageNo(1);
          setSearchFilters({
            ...searchFilters,
            countryId: checkCountryId,
            region: checkRadioCountry
          });
          setVisible(false);
          setCloseModalState(false);
          setFilterError("");
          addQuery("Country", JSON.stringify(checkRadioCountry));
          addQuery("countryId", JSON.stringify(checkCountryId));
          const obj = {
            ...getPrivateParams(),
            _page: 1,
            _perPage: perPage,
            _sort: sortType,
            search:
            props.value === 0 ?
            "" :
            props.job_title ?
            props.job_title.join("$") :
            props.value,

            NearBy: searchFilters.NearBy ? true : null,
            Latitude: localStorage.getItem("latitude") ?
            localStorage.getItem("latitude").toString() :
            null,
            Longitude: localStorage.getItem("longitude") ?
            localStorage.getItem("longitude").toString() :
            null,

            maxDistance: "50",
            hide: hideCheck ? true : null,

            BudgetMax: budget.budgetMax,
            BudgetMin: budget.budgetMin,
            BudgetType: budget.budgetType,
            GigType: jobTypeRadio,
            CityId: checkCityId,
            RegionId: checkRegionId,
            CountryId: checkCountryId,
            Experience: checkBox, //checkRadio
            searchType: searchType,
            SkillsId: searchFilters?.skillsId,
            VisaStatusId: searchFilters?.visa,
            CompanyName: searchFilters.company ? searchFilters.company : null
          };
          const params = { obj };
          dispatch(getCandidatesCount(params));
          dispatch(skillListingCount(params));
          dispatch(skillListingTotalCount(params));
        } else {
          setFilterError("country");
        }
      }

      if (type === "experience") {
        if (checkBox?.length) {
          removeQuery("pageNo");
          setPageNo(1);
          setSearchFilters({
            ...searchFilters,
            ExperienceLevel: checkBox
          });
          setFilter({ ExperienceLevel: checkBox });
          setVisible(false);
          setCloseModalExp(false);
          setFilterError("");
          addQuery("experience", JSON.stringify(checkBox)); //checkRadio
          const obj = {
            ...getPrivateParams(),
            _page: 1,
            _perPage: perPage,
            _sort: sortType,
            search:
            props.value === 0 ?
            "" :
            props.job_title ?
            props.job_title.join("$") :
            props.value,

            NearBy: searchFilters.NearBy ? true : null,
            Latitude: localStorage.getItem("latitude") ?
            localStorage.getItem("latitude").toString() :
            null,
            Longitude: localStorage.getItem("longitude") ?
            localStorage.getItem("longitude").toString() :
            null,

            maxDistance: "50",
            hide: hideCheck ? true : null,

            BudgetMax: budget.budgetMax,
            BudgetMin: budget.budgetMin,
            BudgetType: budget.budgetType,
            GigType: jobTypeRadio,
            CityId: checkCityId,
            RegionId: checkRegionId,
            CountryId: checkCountryId,
            Experience: checkBox, //checkRadio
            searchType: searchType,
            SkillsId: searchFilters?.skillsId,
            VisaStatusId: searchFilters?.visa,
            CompanyName: searchFilters.company ? searchFilters.company : null
          };
          const params = { obj };
          dispatch(getCandidatesCount(params));
          dispatch(skillListingCount(params));
          dispatch(skillListingTotalCount(params));
        } else {
          setFilterError("experience");
        }
      }

      if (type === "profession") {
        if (professionSelected && professionSelected !== "All") {
          if (isNonHC(professionSelected)) {
            removeQuery("skillListing_type");
          }
          setPageNo(1);
          removeQuery("pageNo");
          setFilter({ ProfessionCode: professionSelected });
          setFilterError("");
          const params = { ...obj, GigType: null };
          dispatch(getCandidatesCount(params));
          dispatch(skillListingCount(params));
          dispatch(skillListingTotalCount(params));
          addQuery("ProfessionCode", professionSelected);
          setProfessionDropdownOpen(false);
        } else {
          if (professionSelected === "All") {
            setPageNo(1);
            removeQuery("pageNo");
            removeQuery("ProfessionCode");
            setFilter({ ProfessionCode: null });
            setProfessionDropdownOpen(false);
          }
          setFilterError("profession");
        }
      }
    } else {
      setIsFormOpen(true);
      setFilterError("");
      if (
      !checkRadioLoc &&
      !checkRadioRegion &&
      !checkRadioCountry &&
      !jobTypeRadio &&
      !budget.budgetMax &&
      !budget.budgetMin &&
      !budget.budgetType &&
      !checkRadio &&
      checkBox.length <= 0 &&
      !hideCheck)
      {
        canClose = false;
      } else {
        canClose = true;
        setFilterError("");
      }

      if (checkBox) {
        removeQuery("pageNo");
        setPageNo(1);
        setFilter({ ExperienceLevel: checkBox });
        setSearchFilters({
          ...searchFilters,
          ExperienceLevel: checkBox
        });
        addQuery("experience", JSON.stringify(checkBox));
        const obj = {
          ...getPrivateParams(),
          _page: 1,
          _perPage: perPage,
          _sort: sortType,
          search:
          props.value === 0 ?
          "" :
          props.job_title ?
          props.job_title.join("$") :
          props.value,

          NearBy: searchFilters.NearBy ? true : null,
          Latitude: localStorage.getItem("latitude") ?
          localStorage.getItem("latitude").toString() :
          null,
          Longitude: localStorage.getItem("longitude") ?
          localStorage.getItem("longitude").toString() :
          null,

          maxDistance: "50",
          hide: hideCheck ? true : null,

          BudgetMax: budget.budgetMax,
          BudgetMin: budget.budgetMin,
          BudgetType: budget.budgetType,
          GigType: jobTypeRadio,
          CityId: checkCityId,
          RegionId: checkRegionId,
          CountryId: checkCountryId,
          Experience: checkBox, //checkRadio,
          searchType: searchType,
          SkillsId: searchFilters?.skillsId,
          VisaStatusId: searchFilters?.visa,
          CompanyName: searchFilters.company ? searchFilters.company : null
        };
        const params = { obj };
        dispatch(getCandidatesCount(params));
        dispatch(skillListingCount(params));
        dispatch(skillListingTotalCount(params));
      }

      if (
      budget.budgetMax &&
      budget.budgetMin &&
      budget.budgetMax > budget.budgetMin)
      {
        removeQuery("pageNo");
        setPageNo(1);
        setFilter({
          budgetMax: budget.budgetMax,
          budgetMin: budget.budgetMin,
          budgetType: budget.budgetType
        });
        addQuery("budgetMax", budget.budgetMax);
        addQuery("budgetMin", budget.budgetMin);
        addQuery("budgetType", budget.budgetType);
        const obj = {
          ...getPrivateParams(),
          _page: 1,
          _perPage: perPage,
          _sort: sortType,
          search:
          props.value === 0 ?
          "" :
          props.job_title ?
          props.job_title.join("$") :
          props.value,

          NearBy: searchFilters.NearBy ? true : null,
          Latitude: localStorage.getItem("latitude") ?
          localStorage.getItem("latitude").toString() :
          null,
          Longitude: localStorage.getItem("longitude") ?
          localStorage.getItem("longitude").toString() :
          null,

          maxDistance: "50",
          hide: hideCheck ? true : null,

          BudgetMax: budget.budgetMax,
          BudgetMin: budget.budgetMin,
          BudgetType: budget.budgetType,
          GigType: jobTypeRadio,
          CityId: checkCityId,
          RegionId: checkRegionId,
          CountryId: checkCountryId,
          Experience: checkBox, //checkRadio,
          searchType: searchType,
          SkillsId: searchFilters?.skillsId,
          VisaStatusId: searchFilters?.visa,
          CompanyName: searchFilters.company ? searchFilters.company : null
        };
        const params = { obj };
        dispatch(getCandidatesCount(params));
        dispatch(skillListingCount(params));
        dispatch(skillListingTotalCount(params));
      }

      if (jobTypeRadio) {
        removeQuery("pageNo");
        setPageNo(1);
        setFilter({ skillListing_type: jobTypeRadio });
        addQuery("skillListing_type", jobTypeRadio);
        const obj = {
          ...getPrivateParams(),
          _page: 1,
          _perPage: perPage,
          _sort: sortType,
          search:
          props.value === 0 ?
          "" :
          props.job_title ?
          props.job_title.join("$") :
          props.value,

          NearBy: searchFilters.NearBy ? true : null,
          Latitude: localStorage.getItem("latitude") ?
          localStorage.getItem("latitude").toString() :
          null,
          Longitude: localStorage.getItem("longitude") ?
          localStorage.getItem("longitude").toString() :
          null,

          maxDistance: "50",
          hide: hideCheck ? true : null,

          BudgetMax: budget.budgetMax,
          BudgetMin: budget.budgetMin,
          BudgetType: budget.budgetType,
          GigType: jobTypeRadio,
          CityId: checkCityId,
          RegionId: checkRegionId,
          CountryId: checkCountryId,
          Experience: checkBox, //checkRadio,
          searchType: searchType,
          SkillsId: searchFilters?.skillsId,
          VisaStatusId: searchFilters?.visa,
          CompanyName: searchFilters.company ? searchFilters.company : null
        };
        const params = { obj };
        dispatch(getCandidatesCount(params));
        dispatch(skillListingCount(params));
        dispatch(skillListingTotalCount(params));
      }

      if (checkRadioLoc) {
        removeQuery("pageNo");
        setPageNo(1);
        setSearchFilters({
          ...searchFilters,
          cityId: checkCityId,
          location: checkRadioLoc
        });
        addQuery("City", JSON.stringify(checkRadioLoc));
        addQuery("cityId", JSON.stringify(checkCityId));

        const obj = {
          ...getPrivateParams(),
          _page: 1,
          _perPage: perPage,
          _sort: sortType,
          search:
          props.value === 0 ?
          "" :
          props.job_title ?
          props.job_title.join("$") :
          props.value,

          NearBy: searchFilters.NearBy ? true : null,
          Latitude: localStorage.getItem("latitude") ?
          localStorage.getItem("latitude").toString() :
          null,
          Longitude: localStorage.getItem("longitude") ?
          localStorage.getItem("longitude").toString() :
          null,

          maxDistance: "50",
          hide: hideCheck ? true : null,

          BudgetMax: budget.budgetMax,
          BudgetMin: budget.budgetMin,
          BudgetType: budget.budgetType,
          GigType: jobTypeRadio,
          CityId: checkCityId,
          RegionId: checkRegionId,
          CountryId: checkCountryId,
          Experience: checkBox, //checkRadio,
          searchType: searchType,
          SkillsId: searchFilters?.skillsId,
          VisaStatusId: searchFilters?.visa,
          CompanyName: searchFilters.company ? searchFilters.company : null
        };
        const params = { obj };

        dispatch(getCandidatesCount(params));
        dispatch(skillListingCount(params));
        dispatch(skillListingTotalCount(params));
      }

      if (checkRadioSkill) {
        removeQuery("pageNo");
        setPageNo(1);
        setFilter({
          ...searchFilters,
          skillsId: checkSkillId,
          skill: checkRadioSkill
        });
        setVisible(false);
        setCloseModalSkill1(false);
        setFilterError("");
        addQuery("Skill", JSON.stringify(checkRadioSkill));
        addQuery("skillsId", JSON.stringify(checkSkillId));
        const obj = {
          ...getPrivateParams(),
          _page: 1,
          _perPage: perPage,
          _sort: sortType,
          search:
          props.value === 0 ?
          "" :
          props.job_title ?
          props.job_title.join("$") :
          props.value,

          NearBy: searchFilters.NearBy ? true : null,
          Latitude: localStorage.getItem("latitude") ?
          localStorage.getItem("latitude").toString() :
          null,
          Longitude: localStorage.getItem("longitude") ?
          localStorage.getItem("longitude").toString() :
          null,

          maxDistance: "50",
          hide: hideCheck ? true : null,

          BudgetMax: budget.budgetMax,
          BudgetMin: budget.budgetMin,
          BudgetType: budget.budgetType,
          GigType: jobTypeRadio,
          CityId: checkCityId,
          RegionId: checkRegionId,
          CountryId: checkCountryId,
          // Location: checkRadioLoc,
          Experience: checkBox,
          searchType: searchType,
          SkillsId: searchFilters?.skillsId,
          VisaStatusId: searchFilters?.visa,
          CompanyName: searchFilters.company ? searchFilters.company : null
        };
        const params = { obj };
        dispatch(getCandidatesCount(params));
      }

      //region
      if (checkRadioRegion) {
        removeQuery("pageNo");
        setPageNo(1);
        setSearchFilters({
          ...searchFilters,
          regionId: checkRegionId,
          state: checkRadioRegion
        });
        addQuery("Region", JSON.stringify(checkRadioRegion));
        addQuery("regionId", JSON.stringify(checkRegionId));
        const obj = {
          ...getPrivateParams(),
          _page: 1,
          _perPage: perPage,
          _sort: sortType,
          search:
          props.value === 0 ?
          "" :
          props.job_title ?
          props.job_title.join("$") :
          props.value,

          NearBy: searchFilters.NearBy ? true : null,
          Latitude: localStorage.getItem("latitude") ?
          localStorage.getItem("latitude").toString() :
          null,
          Longitude: localStorage.getItem("longitude") ?
          localStorage.getItem("longitude").toString() :
          null,

          maxDistance: "50",
          hide: hideCheck ? true : null,

          BudgetMax: budget.budgetMax,
          BudgetMin: budget.budgetMin,
          BudgetType: budget.budgetType,
          GigType: jobTypeRadio,
          CityId: checkCityId,
          RegionId: checkRegionId,
          CountryId: checkCountryId,
          Experience: checkBox, //checkRadio,
          searchType: searchType,
          SkillsId: searchFilters?.skillsId,
          VisaStatusId: searchFilters?.visa,
          CompanyName: searchFilters.company ? searchFilters.company : null
        };
        const params = { obj };
        dispatch(skillListingCount(params));
        dispatch(getCandidatesCount(params));
        dispatch(skillListingTotalCount(params));
      }

      if (professionSelected) {
        setPageNo(1);
        setFilter({ ProfessionCode: professionSelected });
        setFilterError("");
        const params = { obj };
        dispatch(skillListingCount(params));
        dispatch(getCandidatesCount(params));
        dispatch(skillListingTotalCount(params));
        addQuery("ProfessionCode", professionSelected);
        setProfessionDropdownOpen(false);
        setVisible(false);
      } else {
        setFilterError("profession");
      }

      //previous industry
      if (
      checkRadioIndustry && isNonHC(
      userProfile?.Professions?.ProfessionCode))
      {
        removeQuery("pageNo");
        setPageNo(1);
        setFilter({
          ...searchFilters,
          industry: checkRadioIndustry,
          industryId: checkIndustryId
        });
        setVisible(false);
        setCloseModalPrev(false);
        setFilterError("");
        addQuery("Industry", JSON.stringify(checkRadioIndustry));
        addQuery("industryId", JSON.stringify(checkIndustryId));
        const obj = {
          ...getPrivateParams(),
          _page: 1,

          _perPage: perPage,

          _sort: sortType,

          search:
          props.value === 0 ?
          "" :
          props.job_title ?
          props.job_title.join("$") :
          props.value,

          NearBy: searchFilters.NearBy ? true : null,

          Latitude: localStorage.getItem("latitude") ?
          localStorage.getItem("latitude").toString() :
          null,

          Longitude: localStorage.getItem("longitude") ?
          localStorage.getItem("longitude").toString() :
          null,

          maxDistance: "50",

          hide: hideCheck ? true : null,

          BudgetMax: budget.budgetMax,

          BudgetMin: budget.budgetMin,

          BudgetType: budget.budgetType,

          GigType: jobTypeRadio,

          CityId: checkCityId,

          RegionId: checkRegionId,

          CountryId: checkCountryId,
          Experience: checkBox,

          searchType: searchType,
          SkillsId: searchFilters?.skillsId,
          VisaStatusId: searchFilters?.visa,
          CompanyName: searchFilters.company ? searchFilters.company : null
        };
        const params = { obj };
        dispatch(getCandidatesCount(params));
        setProfessionDropdownOpen(false);
        setVisible(false);
      } else {
        setFilterError("industry");
      }

      //company

      if (checkRadioCompany) {
        setPageNo(1);
        setFilter({ company: checkRadioCompany });
        setFilterError("");
        const obj = {
          ...getPrivateParams(),
          _page: 1,

          _perPage: perPage,

          _sort: sortType,

          search:
          props.value === 0 ?
          "" :
          props.job_title ?
          props.job_title.join("$") :
          props.value,

          NearBy: searchFilters.NearBy ? true : null,

          Latitude: localStorage.getItem("latitude") ?
          localStorage.getItem("latitude").toString() :
          null,

          Longitude: localStorage.getItem("longitude") ?
          localStorage.getItem("longitude").toString() :
          null,

          maxDistance: "50",

          hide: hideCheck ? true : null,

          BudgetMax: budget.budgetMax,

          BudgetMin: budget.budgetMin,

          BudgetType: budget.budgetType,

          GigType: jobTypeRadio,

          CityId: checkCityId,

          RegionId: checkRegionId,

          CountryId: checkCountryId,

          Experience: checkBox,

          searchType: searchType,
          SkillsId: searchFilters?.skillsId,
          VisaStatusId: searchFilters?.visa,
          CompanyName: searchFilters.company ? searchFilters.company : null
        };
        const params = { obj };
        dispatch(getCandidatesCount(params));
        addQuery("Company", checkRadioCompany);
        setProfessionDropdownOpen(false);
        setVisible(false);
      } else {
        setFilterError("company");
      }

      if (checkRadioVisa) {
        setPageNo(1);
        setFilter({ visa: checkRadioVisa });
        setFilter({ visaName: checkRadioVisaName });
        setFilterError("");
        const obj = {
          ...getPrivateParams(),
          _page: 1,

          _perPage: perPage,

          _sort: sortType,

          search:
          props.value === 0 ?
          "" :
          props.job_title ?
          props.job_title.join("$") :
          props.value,

          NearBy: searchFilters.NearBy ? true : null,

          Latitude: localStorage.getItem("latitude") ?
          localStorage.getItem("latitude").toString() :
          null,

          Longitude: localStorage.getItem("longitude") ?
          localStorage.getItem("longitude").toString() :
          null,

          maxDistance: "50",

          hide: hideCheck ? true : null,

          BudgetMax: budget.budgetMax,

          BudgetMin: budget.budgetMin,

          BudgetType: budget.budgetType,

          GigType: jobTypeRadio,

          CityId: checkCityId,

          RegionId: checkRegionId,

          CountryId: checkCountryId,
          Experience: checkBox,

          searchType: searchType,
          SkillsId: searchFilters?.skillsId,
          VisaStatusId: searchFilters?.visa,
          CompanyName: searchFilters.company ? searchFilters.company : null
        };
        const params = { obj };
        dispatch(getCandidatesCount(params));
        addQuery("VisaStatusId", JSON.stringify(checkRadioVisa));
        addQuery("VisaName", JSON.stringify(checkRadioVisaName));
        setProfessionDropdownOpen(false);
        setVisible(false);
      } else {
        setFilterError("visa");
      }

      //state
      if (checkRadioCountry) {
        removeQuery("pageNo");
        setPageNo(1);
        setSearchFilters({
          ...searchFilters,
          countryId: checkCountryId,
          region: checkRadioCountry
        });
        addQuery("Country", JSON.stringify(checkRadioCountry));
        addQuery("countryId", JSON.stringify(checkCountryId));
        const obj = {
          ...getPrivateParams(),
          _page: 1,
          _perPage: perPage,
          _sort: sortType,
          search:
          props.value === 0 ?
          "" :
          props.job_title ?
          props.job_title.join("$") :
          props.value,

          NearBy: searchFilters.NearBy ? true : null,
          Latitude: localStorage.getItem("latitude") ?
          localStorage.getItem("latitude").toString() :
          null,
          Longitude: localStorage.getItem("longitude") ?
          localStorage.getItem("longitude").toString() :
          null,

          maxDistance: "50",
          hide: hideCheck ? true : null,

          BudgetMax: budget.budgetMax,
          BudgetMin: budget.budgetMin,
          BudgetType: budget.budgetType,
          GigType: jobTypeRadio,
          CityId: checkCityId,
          RegionId: checkRegionId,
          CountryId: checkCountryId,
          Experience: checkBox, //checkRadio,
          searchType: searchType,
          SkillsId: searchFilters?.skillsId,
          VisaStatusId: searchFilters?.visa,
          CompanyName: searchFilters.company ? searchFilters.company : null
        };
        const params = { obj };
        dispatch(getCandidatesCount(params));
        dispatch(skillListingCount(params));
        dispatch(skillListingTotalCount(params));
      }
      if (hideCheck) {
        removeQuery("pageNo");
        setPageNo(1);
        setFilter({ hidePrevious: true });
        const obj = {
          ...getPrivateParams(),
          _page: 1,
          _perPage: perPage,
          _sort: sortType,
          search:
          props.value === 0 ?
          "" :
          props.job_title ?
          props.job_title.join("$") :
          props.value,

          NearBy: searchFilters.NearBy ? true : null,
          Latitude: localStorage.getItem("latitude") ?
          localStorage.getItem("latitude").toString() :
          null,
          Longitude: localStorage.getItem("longitude") ?
          localStorage.getItem("longitude").toString() :
          null,

          maxDistance: "50",

          hide: true,
          BudgetMax: budget.budgetMax,
          BudgetMin: budget.budgetMin,
          BudgetType: budget.budgetType,
          GigType: jobTypeRadio,
          CityId: checkCityId,
          RegionId: checkRegionId,
          CountryId: checkCountryId,
          Experience: checkBox, //checkRadio,
          searchType: searchType,
          SkillsId: searchFilters?.skillsId,
          VisaStatusId: searchFilters?.visa,
          CompanyName: searchFilters.company ? searchFilters.company : null
        };
        const params = { obj };
        dispatch(getCandidatesCount(params));
        dispatch(skillListingCount(params));
        dispatch(skillListingTotalCount(params));
      }

      if (!hideCheck) {
        removeQuery("pageNo");
        setPageNo(1);
        setFilterError("");
        setFilter({ hidePrevious: null });
        const obj = {
          ...getPrivateParams(),
          _page: 1,
          _perPage: perPage,
          search:
          props.value === 0 ?
          "" :
          props.job_title ?
          props.job_title.join("$") :
          props.value,
          hide: null
        };
        const params = { obj };
        dispatch(getCandidatesCount(params));
        dispatch(skillListingCount(params));
      }
      if (canClose) {
        removeQuery("pageNo");
        setPageNo(1);
        setVisible(false);
      }
    }
  };

  const SortResults = () => {
    setSortVisible(false);
    setSortType(window.sort);
    addQuery("sortType", window.sort);

    setsortTypeText(
    url?.search?.
    split("&")?.
    find((param) => param.includes("sortType="))?.
    split("sortType=")[1]?.
    split("&")[0] == "MOST_RECENT" ?
    "New skill listing" :
    url?.search?.
    split("&")?.
    find((param) => param.includes("sortType="))?.
    split("sortType=")[1]?.
    split("&")[0] == "MOST_RELEVANT" ?
    "Most Relevant" :
    url?.search?.
    split("&")?.
    find((param) => param.includes("sortType="))?.
    split("sortType=")[1]?.
    split("&")[0] == "MOST_NEWEST" ?
    "Last Active" :
    url?.search?.
    split("&")?.
    find((param) => param.includes("sortType="))?.
    split("sortType=")[1]?.
    split("&")[0] == "RATINGS_HIGH_TO_LOW" ?
    "Ratings High to Low" :
    url?.search?.
    split("&")?.
    find((param) => param.includes("sortType="))?.
    split("sortType=")[1]?.
    split("&")[0] == "RATINGS_LOW_TO_HIGH" ?
    "Ratings Low to High" :
    url?.search?.
    split("&")?.
    find((param) => param.includes("sortType="))?.
    split("sortType=")[1]?.
    split("&")[0] == "PAY_HI_TO_LOW" ?
    "Desired Rate High to Low" :
    url?.search?.
    split("&")?.
    find((param) => param.includes("sortType="))?.
    split("sortType=")[1]?.
    split("&")[0] == "PAY_LOW_TO_HI" ?
    "Desired Rate Low to High" :
    "Most Relevant");

    setPageNo(1);
    removeQuery("pageNo");
    setCurrentPage(1);
    debounce(hitQuery());
    setCurrentPage(1);
  };

  const onChangePage = (page, pageSize) => {
    setSearchFilters({ ...searchFilters, _page: page });
    hitQuery();
    addQuery("pageNo", page);
    setPageNo(page);
    setCurrentPage(page);
    setPerPage(pageSize);
    setSkillListingIds(
    typeof LocalSelectedSkillListings === "string" ?
    JSON.parse(LocalSelectedSkillListings) :
    LocalSelectedSkillListings);

    setcheckAllClicked(false);
    setSelectText(true);
  };

  function mergeArrays(array1, array2) {
    const uniqueObjects = {}; // Object to track unique IDs
    const resultArray = [];

    // Merge array1
    for (const obj of array1) {
      if (!uniqueObjects[obj.SkillListingId]) {
        uniqueObjects[obj.SkillListingId] = true; // Mark ID as seen
        resultArray.push(obj);
      }
    }

    // Merge array2
    for (const obj of array2) {
      if (!uniqueObjects[obj.SkillListingId]) {
        uniqueObjects[obj.SkillListingId] = true; // Mark ID as seen
        resultArray.push(obj);
      }
    }

    return resultArray;
  }

  function setLocalStorage(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  const onCheckAllChange = (e) => {
    try {
      const currentSkillListings = skillListings.skilllistings.data;
      if (!checkAllClicked) {
        const filteredList = currentSkillListings.filter((data) => {
          const isSelected =
          LocalSelectedSkillListings?.length > 0 ?
          LocalSelectedSkillListings.some(
          (selected) => selected.SkillListingId === data.SkillListingId) :

          false;
          return !isSelected && !data.bidstatus;
        });

        const allSelectedSkillListings = [
        ...filteredList,
        ...(LocalSelectedSkillListings || [])];


        setSkillListingIds(allSelectedSkillListings.slice(0, 24));
        localStorage.setItem(
        "SelectedSkillsSearch",
        JSON.stringify(allSelectedSkillListings.slice(0, 24)));

      } else {
        setSkillListingIds([]);
        localStorage.setItem("SelectedSkillsSearch", JSON.stringify([]));
      }
      setcheckAllClicked(e.target.checked);
      setSelectText(!selectText);
    } catch (error) {
      console.error("Error in onCheckAllChange:", error);
    }
  };

  const placeBid = () => {
    var candidateslistArray = [];
    for (var i = 0; i < skillListingIds.length; ++i) {
      candidateslistArray.push({
        id: skillListingIds[i].SkillListingId,
        AccountId: skillListingIds[i].CreatedBy,
        img: skillListingIds[i]?.users?.Profiles?.PictureUrl,
        name: skillListingIds[i]?.users?.Profiles?.FirstName ?
        skillListingIds[i]?.users?.Profiles?.FirstName +
        "\n" +
        skillListingIds[i]?.users?.Profiles?.LastName :
        skillListingIds[i]?.users?.UserName ?
        skillListingIds[i]?.users?.UserName :
        "Candidate name",

        email: skillListingIds[i]?.users?.EmailAddress ?
        skillListingIds[i]?.users?.EmailAddress :
        "Email address",
        MobilePhone: skillListingIds[i]?.users?.MobilePhone ?
        skillListingIds[i]?.users?.MobilePhone :
        "MobilePhone",
        rating:
        skillListingIds[i]?.users?.Profiles?.Rating == null ||
        skillListingIds[i]?.users?.Profiles?.Rating == "" ||
        skillListingIds[i]?.users?.Profiles?.Rating == undefined ?
        DefaultRating :
        skillListingIds[i]?.users?.Profiles?.Rating,
        reviews:
        skillListingIds[i]?.users?.Profiles?.Review == null ||
        skillListingIds[i]?.users?.Profiles?.Review == "" ||
        skillListingIds[i]?.users?.Profiles?.Review == undefined ?
        "0" :
        skillListingIds[i]?.users?.Profiles?.Review,
        experience:
        skillListingIds[i]?.explevel[0]?.ExperienceLevelName &&
        skillListingIds[i]?.explevel[0]?.ExperienceLevelName != null &&
        skillListingIds[i]?.explevel[0]?.ExperienceLevelName != "" &&
        skillListingIds[i]?.explevel[0]?.ExperienceLevelName != undefined ?
        skillListingIds[i]?.explevel[0]?.ExperienceLevelName :
        "N/A",
        title: skillListingIds[i]?.Title,
        desired_rate: skillListingIds[i]?.MinimumBid?.$numberDecimal ?
        skillListingIds[i]?.MinimumBid?.$numberDecimal?.slice(0, -3) :
        skillListingIds[i]?.MinimumBid ?
        skillListingIds[i]?.MinimumBid :
        "Negotiable",
        bidType:
        skillListingIds[i].BudgetTypes &&
        skillListingIds[i].BudgetTypes?.BudgetTypeName != null &&
        skillListingIds[i].BudgetTypes?.BudgetTypeName != "" &&
        skillListingIds[i].BudgetTypes?.BudgetTypeName != undefined ?
        skillListingIds[i].BudgetTypes?.BudgetTypeName :
        "/N/A",
        profileType: profileTypeRes?.profile?.ProfessionCode,
        lastActive:
        skillListingIds[i]?.users?.LastSuccessfulLoginDate != null ?
        moment(
        skillListingIds[i]?.users?.LastSuccessfulLoginDate).
        fromNow() :
        "N/A"
      });
    }
    setcandidateList(candidateslistArray);
    setplacebidModal(true);
  };
  const gigDetails = getGigDetails();

  const handleAddToMatch = () => {
    try {
      const SkillListingIds = skillListingIds.map((el) => el.SkillListingId);
      if (isTalentSuggestion || props.findMatch) {
        addBatchMatch({
          SkillListingIds,
          GigId: props?.job_id || gigDetails?.JobOrderId
        });
        return;
      } else {
        removeQuery("pageNo");
        history.push({
          pathname: "/choose-gig",
          state: {
            skillListingIds: skillListingIds.map((el) => el.SkillListingId)
          }
        });
      }
    } catch (error) {
      console.warn("Error #4088:", error);
    }
  };

  const addBatchMatch = (payload) => {
    try {
      dispatch(
      addBatchMatches({
        ...payload,
        callBack: successCallBack
      }));

    } catch (error) {}
  };
  const successCallBack = () => {
    try {
      onChangePage(1, perPage);
      setSkillListingIds([]);
      localStorage.removeItem("SelectedSkillsSearch");
    } catch {}
  };

  const cancelBid = () => {
    setSkillListingIds([]);
    setcheckAllClicked(false);
    localStorage.removeItem("SelectedSkillsSearch");
    setSelectText(true);
  };

  const placeBidModalVisisblityHandler = (value) => {
    setplacebidModal(value);
  };

  const onClick = ({ key }) => {
    setPageNo(1);
    removeQuery("pageNo");
    setCurrentPage(1);

    if (key == "most_relevant") {
      setSortType("MOST_RELEVANT");
      addQuery("sortType", "MOST_RELEVANT");
      setsortTypeText("Most relevant");
    } else if (key == "most_recent") {
      setSortType("MOST_RECENT");
      addQuery("sortType", "MOST_RECENT");
      setsortTypeText("New skill listing");
    } else if (key == "most_newest") {
      setSortType("MOST_NEWEST");
      addQuery("sortType", "MOST_NEWEST");

      setsortTypeText("Last Active");
    } else if (key == "ratings_high_to_low") {
      setSortType("RATINGS_HIGH_TO_LOW");
      addQuery("sortType", "RATINGS_HIGH_TO_LOW");
      setsortTypeText("Ratings high to low");
    } else if (key == "ratings_low_to_high") {
      setSortType("RATINGS_LOW_TO_HIGH");
      addQuery("sortType", "RATINGS_LOW_TO_HIGH");
      setsortTypeText("Ratings low to high");
    } else if (key == "PAY_HI_TO_LOW") {
      setSortType("PAY_HI_TO_LOW");
      addQuery("sortType", "PAY_HI_TO_LOW");
      setsortTypeText("Desired rate high to low");
    } else if (key == "PAY_LOW_TO_HI") {
      setSortType("PAY_LOW_TO_HI");
      addQuery("sortType", "PAY_LOW_TO_HI");
      setsortTypeText("Desired rate low to high");
    }
  };

  const menu =
  <Menu onClick={onClick}>
      <Menu.Item
    key="most_relevant"
    className={
    sortTypeText === "Most Relevant" && "sort-values-style-select"}>

      
        Most relevant
      </Menu.Item>
      <Menu.Item
    key="most_recent"
    className={
    sortTypeText === "New skill listing" && "sort-values-style-select"}>

      
        New skill listing
      </Menu.Item>

      <Menu.Item
    key="most_newest"
    className={sortTypeText === "Last Active" && "sort-values-style-select"}>
      
        Last active
      </Menu.Item>

      <Menu.Item
    key="ratings_high_to_low"
    className={
    sortTypeText === "Ratings High to Low" && "sort-values-style-select"}>

      
        Ratings high to low
      </Menu.Item>

      <Menu.Item
    key="ratings_low_to_high"
    className={
    sortTypeText === "Ratings Low to High" && "sort-values-style-select"}>

      
        Ratings low to high
      </Menu.Item>

      <Menu.Item
    key="PAY_HI_TO_LOW"
    className={
    sortTypeText === "Desired Rate High to Low" &&
    "sort-values-style-select"}>

      
        Desired rate high to low
      </Menu.Item>
      <Menu.Item
    key="PAY_LOW_TO_HI"
    className={
    sortTypeText === "Desired Rate Low to High" &&
    "sort-values-style-select"}>

      
        Desired rate low to high
      </Menu.Item>
    </Menu>;


  const onCloseSortModal = () => {
    setSortVisible(false);
  };

  const onCloseFiltersModal = () => {
    setFilterError("");
    setIsFormOpen(false);
    setVisible(false);
  };

  useEffect(() => {
    if (keywords) {
      let uniqueKeywords = [
      ...new Set(keywords?.skillsListing?.map((o) => o._id.toLowerCase()))];

      setUniqueSuggestion(uniqueKeywords);
    }
  }, [keywords]);

  const handleCityChange = (flag) => {
    if (flag) {
      if (emptyCityInput === "") {
        setEmptyCityInput();
      }
    }
    setVisible(flag);
  };

  const applyIntialSuggestionFilters = () => {
    try {
      const storedQuery = localStorage.getItem("talentSearchQuery");
      alertNotification("success", "AI suggested talents successfully");
      history.push(storedQuery);
    } catch (error) {
      console.error("Error in applyIntialSuggestionFilters:", error);
    }
  };

  const handleRegionChange = (flag) => {
    if (flag) {
      if (emptyRegionInput === "") {
        setEmptyRegionInput();
      }
    }
    setVisible(flag);
  };
  const handleSkillChange = (flag) => {
    if (flag) {
      if (emptySkillInput === "") {
        setEmptySkillInput();
      }
    }
    setVisible(flag);
  };
  const handleCountryChange = (flag) => {
    if (flag) {
      if (emptyCountryInput === "") {
        setEmptyCountryInput();
      }
    }
    setVisible(flag);
  };
  //for city
  useEffect(() => {
    if (closeModalLoc) {
      let cleanparam = queryparams?.cityId?.slice(1, -1);
      let array = cleanparam?.split(",");
      array = array?.map(Number);
      array?.length > 0 ? setCheckCityId(array) : setCheckCityId([]);
    }
  }, [closeModalLoc]);

  //for state
  useEffect(() => {
    if (closeModalRegion) {
      const queryparams = GetQueryParams();
      let cleanparam = queryparams?.regionId?.slice(1, -1);
      let array = cleanparam?.split(",");
      array = array?.map(Number);
      array?.length > 0 ? setCheckRegionId(array) : setCheckRegionId([]);
    }
  }, [closeModalRegion]);

  //for country
  useEffect(() => {
    if (closeModalState) {
      const queryparams = GetQueryParams();
      let cleanparam = queryparams?.countryId?.slice(1, -1);
      let array = cleanparam?.split(",");
      array = array?.map(Number);
      array?.length ? setCheckCountryId(array) : setCheckCountryId([]);
    }
  }, [closeModalState]);

  const isShowPrivate = () => {
    return (
      userProfile?.IsPrivateEmployer &&
      !queryparams?.isPrivate &&
      [undefined, false, "false"].includes(props?.jobdetails?.[0]?.isPrivate));

  };

  const handleOnCloseTag = () => {
    try {
      if (searchType === TAL_AUTO_SUGGESTED) {
        removeQuery("skillsPercentages");
        removeQuery("searchType");
        setSearchType("Skills");
      }
    } catch (error) {}
  };

  return (
    <React.Fragment>
      <main
      className={`gql-dashBoardFull ${
      HidePagePvt && "gql-dashBoardFull-multi-bid"
      }`}>
        
        {!HidePagePvt ?
        <>
            <div className="gql-dashboardHeaders">
              <div className="gql-countCheck">
                {skillListings &&
              skillListings.skilllistings > 0 &&
              props.value?.length > 0 ?
              <CountDetail
              gigs={skillListings.length}
              value={props.value} /> :

              null}
              </div>
              <div className="gql-viewAllBtn"></div>
            </div>
            {/* //// Tags//// */}
            {!props.loading && !gqlError ?
          queryparams?.isPrivate ?
          <p className="Pvt-cand-head">Private Candidates</p> :
          loading ?
          <p>
                  Showing {<LoadingOutlined className="count-loader" />} items
                </p> :

          isTalentSuggestion &&
          <div className={"results_descriptiontext"}>
                    <div style={{ display: "flex" }}>
                      <img src={AiImage} />
                      <span style={{ paddingLeft: "10px" }}>
                        Suggested Talents
                      </span>
                      {/* <div
                style={{
                backgroundColor: "#4054B233",
                marginLeft: "10px",
                width: "31px",
                height: "20px",
                borderRadius: "12px",
                textAlign: "center",
                }}
                >
                500
                </div> */}
                    </div>
                    {!isTalentSuggestion &&
            <>
                        Showing{" "}
                        {searchType ?
              skillListings?.skilllistings?.data?.length > 0 &&
              skillListings?.skilllistings?.data[0].TotalCount?.
              count ?
              skillListings?.skilllistings?.data[0].TotalCount?.
              count?.total :
              0 :
              " "}{" "}
                        results{" "}
                        {!props.job_title &&
              <>
                            {"for "}
                            <strong>
                              "
                              {props.value != "" ?
                  props.value?.
                  replaceAll('"', "")?.
                  replaceAll("$", " ,") :
                  searcheyword?.replaceAll('"', "")}
                              "
                            </strong>
                          </>}
              
                      </>}
            {" "}
                  </div> :


          null}
            <Col
          xs={24}
          className={
          windowDimensions.width < 769 ?
          "suggestion-wrdapper-mobile" :
          "suggestion-wrdapper"}>

            
              {uniqueSuggestion ?
            uniqueSuggestion?.map((suggesteditems, index) => {
              return (
                <Tag
                key={index}
                color="default"
                className={"tags"}
                style={{ cursor: "pointer" }}
                onClick={() => onSearch(suggesteditems)}>
                  
                        <div style={{ color: "#9e9e9e" }}>{suggesteditems}</div>
                      </Tag>);

            }) :
            null}
            </Col>

            {/* ////// Dropdowns //// */}
            {searchType == "Skills" ||
          searchType == "workHistory" ||
          searchType == "Match" ||
          searchType == TAL_AUTO_SUGGESTED ?
          windowDimensions.width > 768 ?
          <>
                  <div className="filters-container">
                    <Space wrap className="space">
                      {!authToken ?
                <ProfessionFilter
                setFilterError={setFilterError}
                setProfessionSelected={setProfessionSelected}
                ClearAll={ClearAll}
                setProfessionDropdownOpen={setProfessionDropdownOpen}
                professionDropdownOpen={professionDropdownOpen}
                searchFilters={searchFilters}
                professionSelected={professionSelected}
                windowDimensions={windowDimensions}
                counts={totalCount?.result?.aggregate}
                gqlError={gqlError} /> :


                ""}
                

                      <Dropdown
                destroyPopupOnHide={true}
                overlayClassName="searchResultsFilterDropdown"
                overlay={JobMenu}
                trigger="click"
                className={
                searchFilters?.skillListing_type && "dropdown-job"}

                visible={closeModalSkill}
                onOpenChange={(e) => {
                  setCloseModalSkill(!closeModalSkill);
                  setFilterError("");
                }}>
                  
                        <Button className="skill-list-type-dropdown">
                          Skill listing type{" "}
                          <img
                    alt="img"
                    src={downArrow}
                    style={{
                      width: "8px"
                    }} />
                    
                        </Button>
                      </Dropdown>

                      {/* //skill */}
                      <Dropdown
                overlayClassName="searchResultsFilterDropdown"
                overlay={SkillMenu}
                trigger="click"
                visible={closeModalSkill1}
                onOpenChange={(e) => {
                  setCloseModalSkill1(!closeModalSkill1);
                  setFilterError("");
                }}>
                  
                        <Button
                  className={
                  searchFilters?.skill?.length > 0 ?
                  "visaStatus-dropdown-select" :
                  "visaStatus-dropdown"}

                  onClick={() => {
                    setCloseModalSkill1(!closeModalSkill1);
                  }}>
                    
                          Skill <DownOutlined />
                        </Button>
                      </Dropdown>

                      {/* //country */}
                      <Dropdown
                overlayClassName="searchResultsFilterDropdown"
                overlay={StateMenu}
                trigger="click"
                visible={closeModalState}
                onOpenChange={(e) => {
                  handleCountryChange(e);
                  setCloseModalState(!closeModalState);
                  setFilterError("");
                }}>
                  
                        <Button
                  className={
                  searchFilters.countryId?.length > 0 ?
                  "visaStatus-dropdown-select" :
                  "visaStatus-dropdown"}

                  onClick={() => {
                    setCloseModalState(!closeModalState);
                  }}>
                    
                          Country{" "}
                          <img
                    alt="img"
                    src={downArrow}
                    style={{
                      width: "8px"
                    }} />
                    
                        </Button>
                      </Dropdown>
                      {/* //state */}
                      <Dropdown
                overlayClassName="searchResultsFilterDropdown"
                overlay={RegionMenu}
                trigger="click"
                visible={closeModalRegion}
                onOpenChange={(e) => {
                  handleRegionChange(e);
                  setCloseModalRegion(!closeModalRegion);
                  setFilterError("");
                }}>
                  
                        <Button
                  className={
                  searchFilters.regionId?.length > 0 ?
                  "visaStatus-dropdown-select" :
                  "visaStatus-dropdown"}

                  onClick={() => {
                    setCloseModalRegion(!closeModalRegion);
                  }}>
                    
                          State{" "}
                          <img
                    alt="img"
                    src={downArrow}
                    style={{
                      width: "8px"
                    }} />
                    
                        </Button>
                      </Dropdown>

                      {/* //city */}
                      <Dropdown
                overlayClassName="searchResultsFilterDropdown"
                overlay={locationMenu}
                trigger="click"
                visible={closeModalLoc}
                onOpenChange={(e) => {
                  handleCityChange(e);
                  setCloseModalLoc(!closeModalLoc);
                  setFilterError("");
                }}>
                  
                        <Button
                  className={
                  searchFilters.cityId?.length > 0 ?
                  "visaStatus-dropdown-select" :
                  "visaStatus-dropdown"}>

                    
                          City{" "}
                          <img
                    alt="img"
                    src={downArrow}
                    style={{
                      width: "8px"
                    }} />
                    
                        </Button>
                      </Dropdown>
                      <Dropdown
                destroyPopupOnHide={true}
                overlayClassName="searchResultsFilterDropdown"
                overlay={BudgetMenu}
                className={
                searchFilters?.budgetMin && searchFilters.budgetMax ?
                "dropdown-job" :
                ""}

                trigger="click"
                open={closeModalBudget}
                onOpenChange={() => {
                  setCloseModalBudget(!closeModalBudget);
                  setFilterError("");
                }}>
                  
                        <Button className="visaStatus-dropdown">
                          Budget{" "}
                          <img
                    alt="img"
                    src={downArrow}
                    style={{
                      width: "8px"
                    }} />
                    
                        </Button>
                      </Dropdown>
                      <Dropdown
                destroyPopupOnHide={true}
                overlay={experienceLevel}
                overlayClassName="searchResultsFilterDropdown"
                className={
                searchFilters?.ExperienceLevel?.length &&
                "dropdown-job"}

                trigger="click"
                open={closeModalExp}
                onOpenChange={() => {
                  setCloseModalExp(!closeModalExp);
                  setFilterError("");
                }}>
                  
                        <Button className="skill-list-type-dropdown">
                          Experience level{" "}
                          <img
                    alt="img"
                    src={downArrow}
                    style={{
                      width: "8px"
                    }} />
                    
                        </Button>
                      </Dropdown>

                      {/* //Companies */}
                      <Dropdown
                overlayClassName="searchResultsFilterDropdown"
                overlay={CompanyMenu}
                trigger="click"
                visible={closeModalCompany}
                onOpenChange={(e) => {
                  setCloseModalCompany(!closeModalCompany);
                  setFilterError("");
                }}>
                  
                        <Button
                  className={
                  searchFilters.company ?
                  "visaStatus-dropdown-select" :
                  "visaStatus-dropdown"}

                  onClick={() => {
                    setCloseModalCompany(!closeModalCompany);
                  }}>
                    
                          Company{" "}
                          <img
                    alt="img"
                    src={downArrow}
                    style={{
                      width: "8px"
                    }} />
                    
                        </Button>
                      </Dropdown>

                      {/* //Visa Statuses */}
                      <Dropdown
                overlayClassName="searchResultsFilterDropdown"
                overlay={VisaMenu}
                trigger="click"
                visible={closeModalVisa}
                onOpenChange={(e) => {
                  setCloseModalVisa(!closeModalVisa);
                  setFilterError("");
                }}>
                  
                        <Button
                  className={
                  searchFilters?.visa?.length > 0 ?
                  "visaStatus-dropdown-select" :
                  "visaStatus-dropdown"}

                  onClick={() => {
                    setCloseModalVisa(!closeModalVisa);
                  }}>
                    
                          Visa Status{" "}
                          <img
                    alt="img"
                    src={downArrow}
                    style={{
                      width: "8px"
                    }} />
                    
                        </Button>
                      </Dropdown>

                      {isNonHC(userProfile?.Professions?.ProfessionCode) ?
                <>
                          {/* //Previous Industries */}
                          <Dropdown
                  overlayClassName="searchResultsFilterDropdown"
                  overlay={PrevMenu}
                  trigger="click"
                  visible={closeModalPrev}
                  onOpenChange={(e) => {
                    setCloseModalPrev(!closeModalPrev);
                    setFilterError("");
                  }}>
                    
                            <Button
                    className={
                    searchFilters?.industry?.length > 0 ?
                    "visaStatus-dropdown-select" :
                    "visaStatus-dropdown"}

                    onClick={() => {
                      setCloseModalPrev(!closeModalPrev);
                    }}>
                      
                              Industry{" "}
                              <img
                      alt="img"
                      src={downArrow}
                      style={{
                        width: "8px"
                      }} />
                      
                            </Button>
                          </Dropdown>
                        </> :
                null}

                      {/* All Candidates */}
                      {isShowPrivate() ?
                <Dropdown
                destroyPopupOnHide={true}
                overlayClassName="searchResultsFilterDropdown"
                overlay={CandidateMenu}
                trigger="click"
                className={
                searchFilters?.isPrivateTalent && "dropdown-job"}

                visible={closeCandidateModal}
                onOpenChange={(e) => {
                  setCloseCandidateModal(!closeCandidateModal);
                  setFilterError("");
                }}>
                  
                          <Button className="skill-list-type-dropdown">
                            All candidates{" "}
                            <img
                    alt="img"
                    src={downArrow}
                    style={{
                      width: "8px"
                    }} />
                    
                          </Button>
                        </Dropdown> :
                null}
                    </Space>
                    <div className="applied-filter">
                      <div className="div2-searchResults">
                        {isTalentSuggestion &&
                  searchType !== TAL_AUTO_SUGGESTED ?
                  <div
                  style={{ cursor: "pointer", marginRight: "10px" }}
                  onClick={() => applyIntialSuggestionFilters()}>
                    
                            <img src={AI_Suggested} />
                          </div> :
                  null}
                        <div className="sort-Text">Sort by</div>
                        <Dropdown
                  overlayClassName="sortByFilterDropdown"
                  overlay={menu}
                  trigger={["click"]}
                  className="dropdown1">
                    
                          <Space style={{ border: "none" }}>
                            <a
                      style={{ border: "none" }}
                      onClick={(e) => e.preventDefault()}>
                        
                              <div className="filterDropDownText">
                                {sortTypeText}
                              </div>
                            </a>
                            <img
                      alt="img"
                      src={downArrow}
                      style={{
                        width: "8px",
                        cursor: "pointer",
                        marginBottom: "2px"
                      }} />
                      
                          </Space>
                        </Dropdown>
                      </div>
                    </div>
                  </div>
                  <div className="applied-filters-div">
                    {searchFilters?.ProfessionCode &&
              searchFilters?.ProfessionCode !== "All" ?
              <Tag
              closable={true}
              className="tag-filter"
              onClose={() => {
                handleOnCloseTag();
                setSearchFilters({
                  ...searchFilters,
                  ProfessionCode: null
                });
                setFilter({ ProfessionCode: null });
                setProfessionSelected("All");
                removeQuery("ProfessionCode");
              }}>
                
                        Profession - {searchFilters.ProfessionCode}
                      </Tag> :
              null}

                    {searchFilters?.skillListing_type ?
              <Tag
              closable={true}
              className="tag-filter"
              onClose={() => {
                handleOnCloseTag();
                setSearchFilters({
                  ...searchFilters,
                  skillListing_type: null
                });
                setJobTypeRadios(null);
                removeQuery("skillListing_type");
              }}>
                
                        {searchFilters.skillListing_type?.replaceAll("+", " ")}
                      </Tag> :
              null}
                    {Boolean(searchFilters?.isPrivateTalent) &&
              isShowPrivate() ?
              <Tag
              closable={true}
              className="tag-filter"
              onClose={() => {
                handleOnCloseTag();
                setSearchFilters({
                  ...searchFilters,
                  isPrivateTalent: undefined
                });
                setcandidateTypeRadio(false);
                removeQuery("isPrivateTalent");
              }}>
                
                        Private candidates
                      </Tag> :
              null}
                    {searchFilters.countryId?.length > 0 ?
              searchFilters?.region?.map((res) => {
                return (
                  <Tag
                  key={res.ids}
                  closable={true}
                  className="filter-tag"
                  onClose={() => {
                    handleOnCloseTag();
                    let checkname = res;
                    setSearchFilters({
                      ...searchFilters,
                      region: searchFilters?.region?.filter(
                      (response) => {
                        return response != checkname?.name;
                      }),

                      countryId: searchFilters?.countryId?.filter(
                      (response) => {
                        return response != checkname.id;
                      })

                    });
                    if (searchFilters?.countryId?.length > 1) {
                      addQuery(
                      "Country",
                      JSON.stringify(
                      searchFilters?.region?.filter(
                      (response) => {
                        return response != checkname?.name;
                      })),


                      "replace");

                      addQuery(
                      "countryId",
                      JSON.stringify(
                      searchFilters?.countryId?.filter(
                      (response) => {
                        return response != checkname.id;
                      })),


                      "replace");

                    } else {
                      removeQuery("Country");
                      removeQuery("countryId");
                    }
                  }}>
                    
                              {res.name?.replaceAll("+", " ")}
                            </Tag>);

              }) :
              null}
                    {/* //Region */}
                    {searchFilters.state?.length > 0 ?
              searchFilters?.state?.map((res) => {
                return (
                  <Tag
                  key={res.ids}
                  closable={true}
                  className="filter-tag"
                  onClose={() => {
                    handleOnCloseTag();
                    let checkname = res;
                    setSearchFilters({
                      ...searchFilters,
                      regionId: searchFilters.regionId.filter(
                      (response) => {
                        return response != checkname.id;
                      }),

                      state: searchFilters?.state?.filter(
                      (response) => {
                        return response != checkname?.name;
                      })

                    });
                    if (searchFilters.regionId?.length > 1) {
                      addQuery(
                      "Region",
                      JSON.stringify(
                      searchFilters.state?.filter(
                      (response) => {
                        return response != checkname?.name;
                      })),


                      "replace");

                      addQuery(
                      "regionId",
                      JSON.stringify(
                      searchFilters.regionId.filter(
                      (response) => {
                        return response != checkname.id;
                      })),


                      "replace");

                    } else {
                      removeQuery("Region");
                      removeQuery("regionId");
                    }
                  }}>
                    
                              {res.name?.replaceAll("+", " ")}
                            </Tag>);

              }) :
              null}

                    {/* //state */}
                    {searchFilters?.location ?
              searchFilters?.location?.map((res, index) => {
                return (
                  <Tag
                  key={res.ids}
                  closable={true}
                  className="filter-tag"
                  onClose={() => {
                    handleOnCloseTag();
                    let checkname = res;
                    setCheckRadioLoc(
                    searchFilters?.location?.filter(
                    (response) => {
                      return response?.name != checkname.name;
                    }));


                    setSearchFilters({
                      ...searchFilters,
                      location: searchFilters?.location.filter(
                      (response) => response.ids !== checkname.ids),

                      cityId: searchFilters?.cityId.filter(
                      (response) => {
                        return response != checkname.ids;
                      })

                    });
                    setCheckCityId(
                    searchFilters?.cityId.filter((response) => {
                      return response != checkname.ids;
                    }));

                    if (searchFilters.cityId?.length > 1) {
                      addQuery(
                      "City",
                      JSON.stringify(
                      searchFilters.location.filter(
                      (response) => {
                        return response != checkname.name;
                      })),


                      "replace");

                      addQuery(
                      "cityId",
                      JSON.stringify(
                      searchFilters.cityId.filter(
                      (response) => {
                        return response != checkname.ids;
                      })),


                      "replace");

                    } else {
                      removeQuery("City");
                      removeQuery("cityId");
                    }
                  }}>
                    
                              {res.name?.replaceAll("+", " ")}
                            </Tag>);

              }) :
              null}

                    {searchFilters?.budgetMin && searchFilters?.budgetMax ?
              <Tag
              closable={true}
              className="tag-filter"
              onClose={() => {
                handleOnCloseTag();
                setSearchFilters({
                  ...searchFilters,
                  budgetMin: null,
                  budgetMax: null,
                  budgetType: null
                });
                setBudget({
                  ...budget,
                  budgetMax: null,
                  budgetMin: null,
                  budgetType: null
                });
                setClearForm(true);
                removeQuery("budgetMax");
                removeQuery("budgetMin");
                removeQuery("budgetType");
              }}>
                
                        {"$" +
                searchFilters.budgetMin +
                " - " +
                "$" +
                searchFilters.budgetMax}
                      </Tag> :
              null}
                    {searchFilters?.ExperienceLevel?.length > 0 ?
              searchFilters?.ExperienceLevel?.map((item, index) => {
                return (
                  <Tag
                  key={Math.random()}
                  closable={true}
                  className="tag-filter"
                  onClose={() => {
                    handleOnCloseTag();
                    const res = item;
                    setFilter({
                      ExperienceLevel:
                      searchFilters?.ExperienceLevel?.filter(
                      (response) => {
                        return response != res;
                      })

                    });

                    setCheckRadio(null);
                    if (checkBox && checkBox?.length > 1) {
                      addQuery(
                      "experience",
                      JSON.stringify(
                      searchFilters?.ExperienceLevel?.filter(
                      (response) => {
                        return response != res;
                      })),


                      "replace");

                    } else {
                      removeQuery("experience");
                    }
                    setCheckedBox((prevCheckbox) =>
                    prevCheckbox.filter((item) => item !== res));

                    setSearchFilters({
                      ...searchFilters,
                      ExperienceLevel:
                      searchFilters?.ExperienceLevel?.filter(
                      (response) => {
                        return response != res;
                      })

                    });
                  }}>
                    
                              {item}
                            </Tag>);

              }) :
              null}
                    {searchFilters?.company ?
              <Tag
              closable={true}
              className="tag-filter"
              onClose={() => {
                handleOnCloseTag();
                setSearchFilters({
                  ...searchFilters,
                  company: null
                });
                setCheckRadioCompany(null);
                removeQuery("Company");
              }}>
                
                        {searchFilters?.company?.
                replaceAll("+", " ")?.
                replaceAll("-*", "&")}
                      </Tag> :
              null}

                    {searchFilters.industry?.length > 0 ?
              searchFilters?.industry?.map((res) => {
                return (
                  <Tag
                  key={res?.id}
                  closable={true}
                  className="tag-filter"
                  onClose={() => {
                    handleOnCloseTag();
                    let checkname = res;
                    setSearchFilters({
                      ...searchFilters,
                      industry: searchFilters?.industry?.filter(
                      (response) => {
                        return response?.name != checkname?.name;
                      }),

                      industryId: searchFilters?.industryId?.filter(
                      (response) => {
                        return response != checkname.id;
                      })

                    });
                    if (searchFilters?.industryId?.length > 1) {
                      addQuery(
                      "Industry",
                      JSON.stringify(
                      searchFilters?.industry?.filter(
                      (response) => {
                        return (
                          response?.name != checkname?.name);

                      })),


                      "replace");

                      addQuery(
                      "industryId",
                      JSON.stringify(
                      searchFilters?.industryId?.filter(
                      (response) => {
                        return response != checkname.id;
                      })),


                      "replace");

                    } else {
                      removeQuery("Industry");
                      removeQuery("industryId");
                    }
                  }}>
                    
                              {res?.name?.
                    replaceAll("+", " ")?.
                    replaceAll("-*", "&")}
                            </Tag>);

              }) :
              null}
                    {searchFilters.visa?.length > 0 ?
              searchFilters?.visaName?.map((res) => {
                return (
                  <Tag
                  key={res.id}
                  closable={true}
                  className="filter-tag"
                  onClose={() => {
                    handleOnCloseTag();
                    let checkname = res;
                    setCheckRadioVisaName(
                    checkRadioVisaName.filter((response) => {
                      return response.id != checkname.id;
                    }));

                    setSearchFilters({
                      ...searchFilters,
                      visaName: searchFilters?.visaName?.filter(
                      (response) => {
                        return response != res;
                      })

                    });

                    setCheckRadio(null);
                    setCheckedBox((prevCheckbox) =>
                    prevCheckbox.filter((item) => item !== res));

                    setSearchFilters({
                      ...searchFilters,
                      ExperienceLevel:
                      searchFilters?.ExperienceLevel?.filter(
                      (response) => {
                        return response != res;
                      })

                    });
                    if (searchFilters?.visa?.length > 1) {
                      addQuery(
                      "VisaName",
                      JSON.stringify(
                      searchFilters?.visaName?.filter(
                      (response) => {
                        return response.id != checkname?.id;
                      })),


                      "replace");

                      addQuery(
                      "VisaStatusId",
                      JSON.stringify(
                      searchFilters?.visa?.filter(
                      (response) => {
                        return response != checkname.id;
                      })),


                      "replace");

                    } else {
                      removeQuery("VisaName");
                      removeQuery("VisaStatusId");
                    }
                  }}>
                    
                              {res.name.replaceAll("+", " ")}
                            </Tag>);

              }) :
              null}
                    {searchFilters?.skillsId?.length > 0 ?
              searchFilters?.skill?.map((res) => {
                return (
                  <Tag
                  key={(res || "abc") + Math.random()}
                  closable={true}
                  className="tag-filter"
                  onClose={() => {
                    handleOnCloseTag();
                    let checkname = res;
                    const updatedSkillId =
                    searchFilters?.skillsId?.filter(
                    (response) => {
                      return response != checkname.id;
                    });

                    const updatedSkill =
                    searchFilters?.skill?.filter((response) => {
                      return response?.name != checkname?.name;
                    });
                    setSearchFilters({
                      ...searchFilters,
                      skill: updatedSkill,
                      skillsId: updatedSkillId
                    });
                    if (updatedSkillId?.length > 0) {
                      addQuery(
                      "Skill",
                      JSON.stringify(updatedSkill),
                      "replace");

                      addQuery(
                      "skillsId",
                      JSON.stringify(updatedSkillId),
                      "replace");

                    } else {
                      removeQuery("Skill");
                      removeQuery("skillsId");
                    }
                  }}>
                    
                              {res.name?.replaceAll("+", " ")}
                            </Tag>);

              }) :
              null}
                  </div>
                  <div className="select-all-div">
                    {authToken != null &&
              // !id &&
              skillListings?.skilllistings?.data?.length > 0 &&
              <div className="div1-searchResults">
                          <Checkbox
                className="checkAll-checkbox"
                onChange={onCheckAllChange}
                checked={checkAllClicked}>
                </Checkbox>
                          <div
                style={{ paddingLeft: "10px", paddingTop: "1px" }}>
                  
                            {selectText == true ? "Select" : "Deselect"} all
                            skill listings
                          </div>
                        </div>}
              
                  </div>
                </> :

          <>
                  <Row
            style={{
              justifyContent: "space-between",
              width: "99%",
              marginTop: "3px"
            }}>
              
                    <div
              className="filter-button1"
              onClick={() => setVisible(true)}>
                
                      <img
                className={"filter-button-icon"}
                alt=""
                src={FilterIcon} />
                
                      <div className={"filter-button-text"}>
                        Filter{" "}
                        <Text>{filterCount > 0 && `(${filterCount})`}</Text>{" "}
                      </div>
                    </div>

                    <div
              className="filter-button2"
              onClick={() => setSortVisible(true)}>
                
                      <img
                className={"filter-button-icon"}
                alt=""
                src={SortIcon} />
                
                      <div className={"filter-button-text"}>Sort</div>
                    </div>
                    <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "end",
                marginTop: "10px"
              }}>
                
                      {isTalentSuggestion &&
                searchType !== TAL_AUTO_SUGGESTED ?
                <div
                style={{ cursor: "pointer", marginRight: "10px" }}
                onClick={() => applyIntialSuggestionFilters()}>
                  
                          <img src={AI_Suggested} />
                        </div> :
                null}
                    </div>
                  </Row>
                  <Row
            style={{
              marginTop: "18px",
              paddingLeft: "2px",
              marginBottom: "8px"
            }}>
            </Row>

                  <Drawer
            placement="top"
            height={windowDimensions.height}
            onClose={onCloseFiltersModal}
            open={visible}
            closable={false}
            title={
            <div>
                        <Row>
                          <Col
                xs={4}
                className={"clearAll"}
                style={{ justifyContent: "flex-start" }}
                onClick={clearAllFunction}>
                  
                            Clear all
                          </Col>
                          <Col xs={18} className={"filter-text"}>
                            Filters
                          </Col>
                          <Col
                xs={2}
                style={{ textAlign: "center", cursor: "pointer" }}
                onClick={onCloseFiltersModal}>
                  
                            <CloseOutlined style={{ color: "#9e9e9e" }} />
                          </Col>
                        </Row>
                      </div>}

            centered
            width={"100%"}
            footer={[
            <Button
            key="back"
            onClick={() => applyFilters("mobile")}
            className="modal-button">
              
                        Apply filter
                      </Button>]}>

              
                    <Filters
              showCandidateType={isShowPrivate()}
              prop="prop"
              candidateCounts={counts}
              setFilter={setFilter}
              setBudget={setBudget}
              setClear={setClearForm}
              budget={budget}
              checkBox={checkBox}
              setCheckedBox={setCheckedBox}
              clear={clearForm} //for budget
              setcheck={setCheckRadio}
              check={checkRadio} //for experience level
              setcandidateTypeRadio={setcandidateTypeRadio}
              candidateTypeRadio={candidateTypeRadio}
              setJobTypeRadios={setJobTypeRadios}
              jobTypeRadio={jobTypeRadio} //for job type
              setCheckRadioLoc={setCheckRadioLoc}
              checkRadioLoc={checkRadioLoc} //for location
              setCheckRadioRegion={setCheckRadioRegion}
              checkRadioRegion={checkRadioRegion} //for region
              setCheckRadioCountry={setCheckRadioCountry}
              checkRadioCountry={checkRadioCountry} //for state
              setPrevIndustryObj={setPrevIndustryObj} //for previous industries
              prevIndustryObj={prevIndustryObj}
              checkIndustryObject={checkIndustryObject}
              setCheckIndustryObject={setCheckIndustryObject}
              //for company filter
              setcheckCompany={setCheckRadioCompany}
              checkCompany={checkRadioCompany}
              setFilterCompany={setFilter}
              addQueryCompany={addQuery}
              emptyCompanyInput={emptyCompanyInput}
              setEmptyCompanyInput={setEmptyCompanyInput}
              //for visa statuses
              setCheckVisa={setCheckRadioVisaName}
              checkVisa={checkRadioVisaName}
              setCheckVisaIdArray={setCheckRadioVisa}
              checkVisaIdArray={checkRadioVisa}
              //for visa statuses

              setIndustryRadioCheck={setCheckRadioIndustry}
              industryRadioCheck={checkRadioIndustry}
              setEmptyPrevIndustryInput={setEmptyPrevIndustryInput}
              emptyPrevIndustryInput={emptyPrevIndustryInput}
              setCheckCityId={setCheckCityId}
              checkCityId={checkCityId}
              setCheckRegionId={setCheckRegionId}
              checkRegionId={checkRegionId}
              setCheckCountryId={setCheckCountryId}
              checkCountryId={checkCountryId}
              setlocObj={setCheckLocObject}
              locObj={checkLocObject}
              setregionObj={setCheckRegionObject}
              regionObj={checkRegionObject}
              setcountryObj={setCheckCountryObject}
              countryObj={checkCountryObject}
              authToken={authToken}
              hideCheck={hideCheck}
              setHideCheck={setHideCheck}
              searchFilters={searchFilters}
              setSearchFilters={setSearchFilters}
              addQuery={addQuery}
              removeQuery={removeQuery}
              totalCountError={Object.keys(totalCountError).length}
              gqlError={gqlError}
              emptyCityInput={emptyCityInput}
              emptyRegionInput={emptyRegionInput}
              emptyCountryInput={emptyCountryInput}
              setEmptyCityInput={setEmptyCityInput}
              setEmptyRegionInput={setEmptyRegionInput}
              setEmptyCountryInput={setEmptyCountryInput}
              setProfessionSelected={setProfessionSelected}
              ClearAll={ClearAll}
              setCheckIndustryId={setCheckIndustryId}
              checkIndustryId={checkIndustryId}
              setProfessionDropdownOpen={setProfessionDropdownOpen}
              professionDropdownOpen={professionDropdownOpen}
              professionSelected={professionSelected}
              windowDimensions={windowDimensions}
              counts={totalCount?.result?.aggregate}
              searchLocationFilter={searchLocationFilter}
              //skill type filter
              setskillObj={setCheckSkillObject}
              skillObj={checkSkillObject}
              setIndustryObj={setCheckIndustryObject}
              industryObj={checkIndustryObject}
              setEmptyIndustryInput={setEmptyIndustryInput}
              emptyIndustryInput={emptyIndustryInput}
              setcheckSkill={setCheckRadioSkill}
              checkSkill={checkRadioSkill}
              setFilterSkill={setFilter}
              addQuerySkill={addQuery}
              checkSkillId={checkSkillId}
              setCheckSkillId={setCheckSkillId}
              emptySkillInput={emptySkillInput}
              setEmptySkillInput={setEmptySkillInput}
              searchLocationFilterSkill={searchLocationFilter}
              countCheck={props.job_title} />
              

                    {checkFiltervalidity() &&
              <div className="filter-error-style">
                        Please select any filter
                      </div>}
              
                  </Drawer>

                  {/* Modal for sort */}
                  <Drawer
            placement="top"
            height="540px"
            onClose={onCloseSortModal}
            open={sortvisible}
            closable={false}
            title={
            <div>
                        <Row>
                          <Col xs={22} style={{ textAlign: "left" }}>
                            Sort candidates by
                          </Col>
                          <Col
                xs={2}
                style={{ textAlign: "center", cursor: "pointer" }}
                onClick={onCloseSortModal}>
                  
                            <CloseOutlined style={{ color: "#9e9e9e" }} />
                          </Col>
                        </Row>
                      </div>}

            width={"100%"}
            footer={[
            <Button
            key="back"
            className="modal-button"
            onClick={SortResults}>
              
                        Show results
                      </Button>]}>

              
                    <Filters
              fromSearch={true}
              setSort={() => console.log("")}
              clearSort={clearSort}
              setClearSort={setClearSort}
              selectedOption={sortType} />
              
                  </Drawer>
                  {authToken != null &&
            // !id &&
            // props.value?.length &&
            // !props.loading &&
            skillListings?.skilllistings?.data?.length > 0 ?
            <Col className="select-all">
                      <Checkbox
              onChange={onCheckAllChange}
              checked={checkAllClicked}>
              </Checkbox>
                      <Col style={{ paddingLeft: "10px", paddingTop: "1px" }}>
                        {selectText == true ? "Select" : "Deselect"} all skill
                        listings
                      </Col>
                    </Col> :
            null}
                </> :

          null}
            <div>
              {
            <div
            className={`${
            skillListings?.skilllistings?.data?.length > 0 ?
            "gqll-receivedSkills" :
            ""
            } 
               ${
            skillListings?.skilllistings?.data?.length <= 3 &&
            skillListings?.skilllistings?.data?.length > 1 &&
            windowDimensions.width > 768 ?
            "threeorless" :
            ""
            } ${
            skillListings?.skilllistings?.data?.length == 1 ?
            "onlyone" :
            ""
            }`}
            Pagination={true}>
              
                  {gqlError ?
              <div className="noJobsContainer">
                      <img
                src={emptyresult}
                alt="no-jobsimg"
                className="joblisting-noimg"
                style={{ width: "15rem", height: "9.3rem" }}>
                </img>
                      <>
                        <div style={{ width: "max-content" }}>
                          <p className="NoResultText"> Something went wrong</p>
                          <p className="NoResultText2">Please Try again</p>
                        </div>
                      </>
                    </div> :
              skillListings?.skilllistings?.data?.length === 0 ?
              <div className="noJobsContainer-zero">
                      <img
                src={emptyresult}
                alt="no-jobsimg"
                className="joblisting-noimg"
                style={{ width: "15rem", height: "9.3rem" }}>
                </img>
                      <>
                        <div>
                          <p className="NoResultText">
                            {" "}
                            No results found For your search{" "}
                          </p>
                          <p className="NoResultText2">
                            Try searching something else
                          </p>
                        </div>
                      </>
                    </div> :
              skillListings && skillListings.skilllistings ?
              skillListings?.skilllistings?.data?.map((data, index) => {
                return (
                  <GigsCard
                  key={index}
                  all_data={skillListings?.skilllistings.data}
                  findMatch={props.findMatch}
                  searchType={searchType}
                  currentPage={currentPage}
                  marginTop={2}
                  totalRecords={
                  skillListings?.skilllistings?.data?.length}

                  {...data}
                  token={authToken}
                  skillListingIds={skillListingIds}
                  setSkillListingIds={setSkillListingIds}
                  setcheckAllClicked={setcheckAllClicked}
                  localStorageKey={"SelectedSkillsSearch"}
                  setLocalStorage={setLocalStorage}
                  setCandidateId={() => console.warn("")}
                  job_id={props?.job_id ?? null}
                  jobdetails={props.jobdetails}
                  isTalentSuggestion={isTalentSuggestion} />);


              }) :
              loading ?
              <>
                      <div className="gql-loader">
                        <LoadingOutlined />
                      </div>
                    </> :
              null}
                </div>}
            
              {skillListings?.skilllistings?.data?.length == undefined ||
            loading &&
            <div className="gql-loader">
                    <LoadingOutlined />
                  </div>}
            
            </div>

            {windowDimensions.width < 769 &&
          authToken != null &&
          skillListingIds?.length > 0 ?
          <div xs={24} className="multi-bid-btn-div">
                <Button
            className={"btn-multi-bids multi-bid-match-btn-mob"}
            onClick={handleAddToMatch}
            disabled={batchMatchLoading}>
              
                  <Text className="multi-bids-btn-text-match">
                    Add to match{" "}
                    {skillListingIds?.length > 0 ?
                `( ${skillListingIds?.length} Skill ${
                skillListingIds?.length > 1 ? "listings" : "listing"
                })` :
                null}{" "}
                    {batchMatchLoading ?
                <LoadingOutlined style={{ marginLeft: "3px" }} /> :
                null}
                  </Text>
                </Button>
                <Button className={"btn-multi-bids"} onClick={placeBid}>
                  <Text className="multi-bids-btn-text">
                    Place a bid{" "}
                    {skillListingIds?.length > 0 ?
                `( ${skillListingIds?.length} Skill ${
                skillListingIds?.length > 1 ? "listings" : "listing"
                })` :
                null}
                  </Text>
                </Button>

                <button
            className="mobile-cancel-bid-button"
            onClick={cancelBid}>
              
                  Cancel
                </button>
              </div> :
          authToken != null && skillListingIds?.length > 0 ?
          <div className="btn-multi-div">
                <button className={"btn-multi-bids"} onClick={placeBid}>
                  Place a bid{" "}
                  {skillListingIds?.length > 0 ?
              `( ${skillListingIds?.length} Skill ${
              skillListingIds?.length > 1 ? "listings" : "listing"
              } )` :
              null}
                </button>
                <button
            className="btn-multi-bids-match"
            onClick={handleAddToMatch}
            disabled={batchMatchLoading}>
              
                  Add to matches{" "}
                  {skillListingIds?.length > 0 ?
              `( ${skillListingIds?.length} Skill ${
              skillListingIds?.length > 1 ? "listings" : "listing"
              } )` :
              null}{" "}
                  {batchMatchLoading ?
              <LoadingOutlined style={{ marginLeft: "3px" }} /> :
              null}
                </button>

                <button
            className="desktop-cancel-bid-button"
            onClick={cancelBid}>
              
                  Cancel
                </button>
              </div> :
          null}
            {skillListings?.skilllistings?.data?.length > 0 &&
          skillListings?.skilllistings?.data?.[0]?.TotalCount?.count &&
          skillListings?.skilllistings?.data?.[0]?.TotalCount?.count?.total &&
          !gqlError ?
          windowDimensions.width > 769 ?
          <div style={{ margin: "auto", marginTop: "30px" }}>
                  <Pagination
            total={
            skillListings?.skilllistings?.data?.[0]?.TotalCount?.count ?
            skillListings?.skilllistings?.data[0].TotalCount?.
            count?.total :
            ""}

            pageSize={perPage}
            defaultCurrent={currentPage}
            current={currentPage}
            onChange={(page, pageSize) => onChangePage(page, pageSize)}
            hideOnSinglePage={true}
            showSizeChanger={false} />
            
                </div> :

          <div>
                  <MobilePagination
            span={24}
            current={currentPage}
            defaultPageSize={queryparams?.isPrivate ? 100 : 20}
            total={
            skillListings?.skilllistings?.data?.length > 0 &&
            skillListings?.skilllistings?.data[0].TotalCount?.count ?
            skillListings?.skilllistings?.data[0].TotalCount?.
            count?.total :
            ""}

            onChange={(page) => onChangePage(page, 20)} />
            
                </div> :

          null}
          </> :
        null}
        <PlaceBidModal
        visible={placebidModal}
        placeBidModalVisisblityHandler={placeBidModalVisisblityHandler}
        selectedCandidates={candidateList}
        multiBid={candidateList.length == 1 ? false : true}
        setSkillListingIds={setSkillListingIds}
        skillListingIds={skillListingIds}
        setSelectedCandidates={setcandidateList}
        setcheckAllClicked={setcheckAllClicked}
        setHidePagePvt={setHidePagePvt}
        desired_rate={
        candidateList.length == 1 ? candidateList[0]?.desired_rate : 1} />

        
      </main>
    </React.Fragment>);

});

const mapStateToProps = (state) => {
  return {
    loading: state.searchSkillListingReducer.loading,
    skillListings: state.searchSkillListingReducer.skillListings,
    value: state.searchSkillListingReducer.searchvalue,
    error: state.searchSkillListingReducer,
    token: state.authReducer.user?.authToken,
    authToken: state.authReducer.user.authToken,
    type: state.searchSkillListingReducer.searchtype,
    searchIconClicked: state.searchSkillListingReducer.searchIconClicked
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    SearchResponseRequested: (params) => {
      dispatch(SearchResponseRequested(params)); // action dispatched
    },
    searchResponse: (params) => {
      dispatch(SearchResponse(params)); // action dispatched
    },
    searchValue: (params) => {
      dispatch(SearchValue(params)); // action dispatched
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchResults);